export const zhTranslations = {
  companyInfo: {
    title: "公司資訊",
    description: "建立公司資訊，節省您在管理時所花費的時間。建立只需兩分鐘。",
    basicInfo: "基本資訊",
    companyName: "公司名稱",
    businessIdNumber: "統一編號",
    representative: "負責人名稱",
    business: "營業項目",
    capital: "資本額",
    contactInfo: "聯絡資訊",
    email: "Email",
    localPhone: "市內電話",
    fax: "傳真",
    contact: "聯絡人",
    phone: "電話",
    department: "部門",
    address: "聯絡地址",
    city: "縣市",
    district: "行政區",
    postalCode: "郵遞區號",
    fullAddress: "地址",
    advancedSettings: "進階設定",
    logo: "Logo",
    website: "網站",
    companyAbbreviation: "公司簡稱",
    invoiceTitle: "發票抬頭",
    invitationCode: "邀請碼",
    enterInvitationCode: "輸入邀請碼",
    errorFetchingData: "獲取公司資料時發生錯誤：",
    errorUpdatingData: "更新公司資料時發生錯誤：",
    forbidden: "用戶沒有權限操作此功能",
    saveSuccess: "公司資訊儲存成功",
    logoUploadSuccess: "Logo上傳成功",
    logoUploadError: "Logo上傳失敗",
    uploading: "上傳中...",
    uploadLogo: "上傳Logo",
    noLogo: "未上傳Logo",
    save: "修改完成",
  },
  addCompany: {
    title: "新增公司",
    description: "建立公司資訊，節省您在管理時所花費的時間。建立只需兩分鐘。",
    basicInfo: "基本資訊",
    companyInfo: "公司資訊",
    businessIdNumber: "統一編號",
    representative: "負責人名稱",
    business: "營業項目",
    capital: "資本額",
    contactInfo: "聯絡資訊",
    localPhone: "市內電話",
    fax: "傳真",
    contact: "聯絡人",
    phone: "電話",
    department: "部門",
    contactAddress: "聯絡地址",
    city: "縣市",
    district: "行政區",
    postalCode: "郵遞區號",
    address: "地址",
    advancedSettings: "進階設定",
    logo: "Logo",
    website: "網站",
    companyAbbreviation: "公司簡稱",
    invoiceTitle: "發票抬頭",
    invitationCode: "邀請碼",
    enterInvitationCode: "輸入邀請碼",
    cancel: "取消",
  },
  login: {
    title: "登入",
    googleLogin: "Google登錄",
    continueWithGoogle: "使用Google繼續",
    processingLogin: "處理登入中...",
    or: "或",
    account: "帳號",
    password: "設定密碼",
    passwordPlaceholder: "請輸入六位數字組合",
    rememberAccount: "記住帳號",
    noAccount: "沒有帳號？ 立即註冊",
    accountRequired: "帳號不可為空",
    passwordRequired: "密碼不可為空",
    loginError: "帳號或是密碼錯誤。",
  },
  signup: {
    passwordTooShort: "密碼太短",
    passwordTooShortDescription: "密碼長度至少需要 8 個字元",
    title: "註冊",
    googleLogin: "快速註冊",
    or: "或",
    email: "Email",
    setPassword: "設定密碼",
    confirmPassword: "確認密碼",
    passwordPlaceholder: "請輸入六位數字組合",
    register: "註冊",
    haveAccount: "已有帳號？ 立即登入",
    name: "姓名＊",
    phoneNumber: "手機號碼",
    country: "國家及地區＊",
    bio: "個人簡介",
    howDidYouHear: "從哪個管道得知廣達ERP管道：",
    companyRequirement: "公司要求",
    friendRecommendation: "親友推薦",
    internet: "網絡",
    exhibition: "展覽/博覽會",
    emailNotification: "信件",
    agent: "代理商/經銷商",
    confirm: "確定",
    allFieldsRequired: "所有欄位都必須填寫",
    allFieldsRequiredDescription: "請確保所有欄位都已填寫完整",
    passwordMismatch: "密碼不一致",
    passwordMismatchDescription: "密碼與確認密碼不相符，請重新輸入",
    registerSuccess: "註冊成功",
    registerSuccessDescription: "帳號已成功建立",
    registerFailed: "註冊失敗",
    registerFailedDescription: "註冊過程中發生錯誤，請稍後重試",
    serverError: "伺服器錯誤，請稍後重試",
  },
  hrMain: {
    basicInfo: "基本資訊",
    companyCalendar: "行事曆",
    companyInfo: "公司資訊",
    employeeManagement: "員工管理",
    departmentManagement: "部門管理",
    warRoom: "戰情室",
    subscriptionPlan: "訂閱方案",
    projectManagement: "專案管理",
    quotationStage: "專案列表",
    archivedProjects: "已封存",
    editQuotationStage: "編輯專案列表",
    productionPreparation: "生產準備階段",
    productionStage: "生產階段",
    finance: "財務",
    accountsReceivable: "應收帳款(客戶)",
    accountsPayable: "應付帳款(供應商/信用卡/個人)",
    bank: "銀行",
    bankManagement: "銀行管理",
    product: "商品",
    itemEditor: "品項編輯器",
    warehouse: "倉儲",
    warehouseLocation: "倉庫與儲位管理",
    stockHistory: "進出貨歷程",
    warehouseSystem: "倉儲管理系統",
    productManagement: "商品管理",
    inventoryManagement: "入庫單管理",
    inventoryCreated: "已建立",
    inventoryDone: "入庫單總表",
    materialRequest: "領料單管理",
    materialRequestCreated: "已建立",
    materialRequestDone: "領料單總表",
    purchase: "採購",
    purchaseOrder: "採購單",
    draft: "草稿",
    underReview: "審核中",
    approved: "已審核",
    completed: "已完成",
    partner: "合作方",
    partnerList: "合作方列表",
    disabled: "已停用",
    materialBOM: "材料BOM",
    addMaterialBOM: "新增材料BOM",
    boltBOM: "螺絲BOM",
    addBoltBOM: "新增螺絲BOM",
    designBOM: "設計BOM",
    addDesignBOM: "新增設計BOM",
    // Additional keys for HRMainPage
    underReviewStatus: "審核中",
    purchaseOrderDraft: "採購單草稿",
    purchaseOrderUnderReview: "採購單審核中",
    purchaseOrderApproved: "採購單已審核",
    purchaseOrderCompleted: "採購單已完成",
    rfq: "詢價單",
    rfqDraft: "詢價單草稿",
    rfqUnderReview: "詢價單審核中",
    rfqCompleted: "詢價單已完成",
    inventoryManagementCreated: "入庫單管理已建立",
    inventoryManagementCompleted: "入庫單管理已完成",
    materialRequestCreatedPage: "領料單管理已建立",
    materialRequestCompletedPage: "領料單管理已完成",
    edit: "編輯",
    list: "列表",
    // Add buttons and actions
    add: "新增",
    addPartner: "新增合作方",
    addEmployee: "新增員工",
    addCompany: "新增公司",
    addDepartment: "新增部門",
    addProduct: "新增商品",
    addWarehouse: "新增倉庫",
    addInventory: "新增入庫單",
    addStockRequest: "新增領料單",
    addPurchaseOrder: "新增採購單",
    // Manual actions
    manualAdd: "手動新增",
    // Success messages
    createSuccess: "建立成功！",
    editSuccess: "編輯成功",
    deleteSuccess: "刪除成功",
    editFailed: "編輯失敗",
    createPartnerSuccess: "建立合作方成功！",
    createCompanySuccess: "新增公司成功！",
    createDepartmentSuccess: "建立部門成功！",
    createEmployeeSuccess: "建立員工成功！",
    createProductSuccess: "建立商品成功！",
    createWarehouseSuccess: "建立倉庫成功！",
    createInventorySuccess: "建立入庫單成功！",
    createStockRequestSuccess: "建立領料單成功！",
    createPurchaseOrderSuccess: "建立採購單成功！",
    editWarehouseSuccess: "編輯倉儲成功！",
    // Confirmation and form buttons
    confirm: "確定",
    cancel: "取消",
    save: "儲存",
    delete: "刪除",
    deactivate: "停用",
    reactivate: "重新啟用",
    apply: "立即申請",
    cancelApplication: "取消申請",
    confirmDeactivation: "確定停用",
    confirmEdit: "確定編輯",
    confirmExcelEdit: "確定編輯Excel",
    openImmediately: "立即開啟",
    // Empty state messages
    noPartnerDataYet: "您尚未新增合作方資料！你可以試試：",
    noProductDataYet: "您尚未新增商品管理資料！你可以試試：",
    noWarehouseDataYet: "您尚未新增倉儲資料！你可以試試：",
    noEmployeeDataYet: "您尚未新增員工資料！你可以試試：",
    // Form confirmations
    confirmCancelAddEmployee: "您確定要取消新增員工嗎？",
    // Work item actions
    editWorkItem: "編輯工項",
    deleteWorkItem: "刪除工項",
    // Placeholders
    enterItemName: "請輸入工項名稱",
    selectPersonnel: "請選擇人員",
    selectScanCount: "請選擇掃描通過支數",
    enterCharacters: "輸入字元",
    enterSupervisorName: "輸入主管姓名",
    enterMemberName: "輸入成員姓名",
  },
  departmentManagement: {
    noDepartments: "您尚未新增部門資料！你可以試試：",
    quickCreate: "快速建立",
    manualAdd: "手動新增",
    addDepartment: "新增部門",
    code: "代號",
    name: "名稱",
    description: "部門描述",
    searchPlaceholder: "搜尋部門...",
    errorFetchingData: "獲取部門資料時發生錯誤：",
  },
  departmentPage: {
    departmentName: "部門名稱",
    departmentCode: "部門代號",
    departmentDescription: "部門描述",
    departmentLeaders: "部門主管",
    departmentMembers: "部門成員",
    deleteDepartment: "刪除部門",
    errorFetchingData: "獲取部門資料時發生錯誤：",
    errorDeletingData: "刪除部門資料時發生錯誤：",
  },
  productionPlanFlow: {
    nodeAlreadyHasParent: "此節點已經有父節點，無法再添加父節點",
    invalidConnection: "無效的連接: {sourceType} 不能連接到 {targetType}",
    sourceOrTargetNotFound: "找不到源節點或目標節點",
    zone: "分區",
    batch: "分批",
    package: "構件包",
    building: "建築",
    layerColors: "圖層顏色",
    deleteConfirmTitle: "確認刪除",
    deleteConfirmMessage: "確認刪除選取的項目？",
    cancel: "取消",
    priorityMode: "優先序",
    prioritySave: "儲存",
    priorityDuplicate: "優先序不能重複",
    startTime: "開始時間",
    endTime: "結束時間",
    timeInvalid: "結束時間不能早於開始時間",
  },
  signPrint: {
    exitTitle: "確定要離開列印嗎？",
    exitContent: "離開後，文件上放置的簽名不會保留。",
    exitOk: "離開",
    exitCancel: "繼續編輯",
    sign: "簽名",
    print: "列印",
    close: "關閉",
    signature: "簽名",
    removeSignature: "移除簽名",
    resizeSignature: "調整簽名大小",
    dragHint: "拖曳簽名到文件上的位置（點一下則放在畫面中央）；放好後可拖曳移動、拖右下角調整大小、按 × 移除，再按「列印」。",
  },
  docAnnotate: {
    missingFile: "找不到要開啟的文件",
    viewDocument: "檢視文件",
    tool: {
      pan: "捲動",
      select: "選取 / 移動",
      pen: "手寫",
      text: "打字",
      rect: "方框",
      rectFilled: "實心方框",
      ellipse: "圓形",
      ellipseFilled: "實心圓形",
      arrow: "箭頭",
      signature: "簽名",
    },
    color: "顏色 {{color}}",
    width: "粗細 {{width}}",
    undo: "復原",
    redo: "重做",
    delete: "刪除選取的註解",
    zoomIn: "放大",
    zoomOut: "縮小",
    download: "下載註解版",
    close: "關閉",
    downloaded: "已下載註解版，原檔未變更",
    downloadFailed: "下載失敗，請稍後再試",
    loadFailed: "無法在此開啟文件",
    openInNewTab: "在新分頁開啟",
    textPlaceholder: "輸入文字，Enter 完成",
    annotatedSuffix: "註解",
    closeConfirmTitle: "關閉文件？",
    closeConfirm: "註解不會存回系統，關閉後將會遺失。需要的話請先下載註解版。",
    closeAnyway: "仍要關閉",
    keepEditing: "繼續編輯",
    unlockTitle: "使用簽名檔",
    unlockHint: "請輸入簽名密碼以取得你的簽名檔。",
    signatureReady: "簽名檔已就緒，可拖曳到文件上",
    signatureMissingTitle: "尚未上傳簽名檔",
    signatureMissing: "請先到「人資 > 員工」編輯自己的資料，上傳簽名檔並設定簽名密碼。",
    signatureDragHint: "拖曳簽名到文件上，或選擇「簽名」工具後點擊文件放置；放置後可拖曳角落調整大小。",
    ok: "知道了",
  },
  quotation: {
    downloadError: "下載失敗",
    downloadErrorDesc: "無法直接下載，已改為開啟檔案，請手動儲存",
    basicInfo: "基本資訊",
    name: "名稱",
    date: "日期",
    partner: "合作方",
    customer: "合作方（客戶）",
    remarks: "備註",
    address: "地址",
    projectStatus: "專案狀態",
    company: "公司",
    city: "縣市",
    district: "行政區",
    postalCode: "郵遞區號",
    fullAddress: "完整地址",
    fileUpload: "公務檔案",
    contractUpload: "財務檔案",
    addFile: "新增檔案",
    businessManagementSystem: "業務管理系統",
    managePartnersAndOrders: "管理合作夥伴與訂單資訊",
    noName: "未命名",
    noPartner: "未設定合作方",
    openGoogleMaps: "在 Google 地圖中開啟",
    collapse: "收起",
    expand: "展開",
    addressInfo: "地址資訊",
    namePlaceholder: "請輸入名稱",
    datePlaceholder: "請選擇日期",
    partnerPlaceholder: "請選擇合作方",
    cityPlaceholder: "請輸入縣市",
    districtPlaceholder: "請輸入行政區",
    postalCodePlaceholder: "請輸入郵遞區號",
    fullAddressPlaceholder: "請輸入完整地址",
    remarksPlaceholder: "請輸入備註資訊",
    viewFiles: "查看已上傳檔案",
    clickToUpload: "點擊或拖曳檔案到此處",
    clickToUploadContract: "上傳合約文件",
    supportedFormats: "支援各種文件格式",
    viewFile: "查看檔案",
    downloadFile: "下載檔案",
    deleteFile: "刪除",
    folder: "資料夾",
    backToFolders: "返回資料夾",
    files: "個檔案",
    noFiles: "此資料夾沒有檔案",
    selectFolder: "選擇資料夾",
    selectFolderDescription: "請選擇要上傳到哪個資料夾",
    viewContract: "查看合約文件",
    supportedContractFormats: "支援 PDF、Word 等格式",
    uploadSuccess: "上傳成功",
    fileUploadedSuccessfully: "檔案已成功上傳",
    contractUploadedSuccessfully: "合約已成功上傳",
    fileUploadFailed: "公務檔案上傳失敗",
    contractUploadFailed: "財務檔案上傳失敗",
    fileDeletedSuccessfully: "檔案已成功刪除",
    contractDeletedSuccessfully: "合約已成功刪除",
    deleteError: "刪除失敗",
    fileDeleteFailed: "檔案刪除失敗",
    contractDeleteFailed: "合約刪除失敗",
    createQuotationAnalysisTable: "建立報價分析表（繫定報價單）",
    management: "專案管理",
    list: "專案列表",
    add: "新增專案",
    edit: "編輯專案",
    view: "查看專案",
    quotationStage: "報價階段",
    editQuotationStage: "編輯報價階段",
    projectManagement: "專案管理",
    projectName: "專案名稱",
    quotationDate: "報價日期",
    partnerCompany: "合作方公司",
    projectRemarks: "專案備註",
    partnerAddress: "合作方地址",
    contactInfo: "聯絡資訊",
    save: "儲存",
    cancel: "取消",
    create: "建立",
    submitEdit: "送出編輯",
    delete: "刪除",
    errorFetchingData: "獲取報價資料時發生錯誤：",
    errorFetchingPartnerData: "獲取合作方資料時發生錯誤：",
    uploadError: "上傳檔案時發生錯誤：",
    csvParsingError: "CSV 解析錯誤：",
    saveSuccess: "專案資訊儲存成功",
    createSuccess: "專案建立成功",
    updateSuccess: "專案更新成功",
    deleteSuccess: "專案刪除成功",
    requiredField: "此欄位為必填",
    createProjectList: "建立專案列表",
    createProjectListSuccess: "建立專案列表成功！",
    confirm: "確定",
    addProject: "新增專案",
    searchName: "搜尋名稱",
    selectDate: "選擇日期",
    searchPartner: "搜尋合作方",
    searchFile: "搜尋檔案名稱",
    allFolders: "全部資料夾",
    searchResults: "搜尋結果",
    noMatchedFiles: "沒有符合條件的檔案",
    search: "搜尋",
    clear: "清除",
    progressManagement: "工程進度管理",
    progressDetail: "進度詳細",
    processedComponents: "加工完成構件",
    noProgressData: "無進度資料",
    thresholdSettings: "進度閾值設置",
    lowThreshold: "低閾值（紅色）",
    highThreshold: "高閾值（綠色）",
    uploadErrorTitle: "上傳失敗",
    deleteSuccessTitle: "刪除成功",
    deleteErrorTitle: "刪除失敗",
    meetingRecords: "H. 會議記錄",
    importantNotes: "I. 注意事項",
    validationError: "驗證錯誤",
    pleaseSelectPartner: "請選擇合作方",
    archive: "封存",
    archived: "已封存",
    archiveProject: "封存專案",
    archiveDescription: "封存後專案會移到「已封存」清單，並且無法再編輯專案資料（含生產計劃儲存）。此操作無法復原。",
    archiveConfirmTitle: "確認封存此專案？",
    archiveConfirmContent: "封存後將無法再編輯此專案，也無法解除封存。確定要繼續嗎？",
    archiveSuccess: "專案已封存",
    archiveFailed: "封存失敗",
    archivedHint: "此專案已封存，無法再編輯。",
    noArchivedProjects: "沒有已封存的專案",
  },
  header: {
    backToCompanyList: "回到公司資訊",
    logout: "登出",
    notSet: "未設定",
    updatePassword: "修改密碼",
    currentPassword: "目前密碼",
    newPassword: "新密碼",
    confirmPassword: "確認新密碼",
    passwordMismatch: "新密碼不一致",
    passwordUpdateSuccess: "密碼更新成功",
    passwordUpdateFailed: "密碼更新失敗",
  },
  notificationCenter: {
    title: "通知中心",
    tabAll: "全部",
    tabUnread: "未讀",
    markAllRead: "全部標為已讀",
    markRead: "標為已讀",
    markUnread: "標為未讀",
    empty: "目前沒有通知",
    justNow: "剛剛",
    minutesAgo: "{{count}} 分鐘前",
    hoursAgo: "{{count}} 小時前",
    daysAgo: "{{count}} 天前",
    fallbackTitle: "系統通知",
    loadError: "無法載入通知",
    updateError: "更新通知狀態失敗",
    navigateError: "無法跳轉至來源頁面",
    types: {
      purchaseOrder: {
        pendingApproval: {
          title: "採購單待審核",
          description: "有一筆採購單正在等待您的審核。",
        },
      },
      productInventory: {
        belowSafetyStock: {
          title: "庫存低於下限",
          description: "部分品項的庫存已低於安全下限，請盡快補貨。",
        },
      },
      accountsPayableDetail: {
        paymentDueReminder: {
          title: "應付款項到期提醒",
          description: "有一筆應付款項即將到期，請留意付款期限。",
        },
      },
      accountsReceivableDetail: {
        paymentDueReminder: {
          title: "應收款項到期提醒",
          description: "有一筆應收款項即將到期，請留意收款狀況。",
        },
      },
      accountsReceivable: {
        billingDueReminder: {
          title: "請款日期到期提醒",
          description: "有一筆應收帳款已到請款日期，請安排請款。",
        },
        performanceBondRetrievalReminder: {
          title: "履約保證取回提醒",
          description: "有一筆履約保證已到可取回日期，請安排取回。",
        },
        warrantyBondRetrievalReminder: {
          title: "保固本票取回提醒",
          description: "有一筆保固本票已到可取回日期，請安排取回。",
        },
        engineeringInsuranceExpiryReminder: {
          title: "工程保險到期提醒",
          description: "有一筆工程保險即將到期，請留意續保。",
        },
      },
    },
    samples: {
      approval: {
        title: "採購單待審核",
        description: "有一筆新的採購單正在等待您的審核。",
      },
      inventory: {
        title: "庫存低於下限",
        description: "部分品項的庫存已低於安全下限，請盡快補貨。",
      },
      finance: {
        title: "應付款項提醒",
        description: "有一筆應付款項即將到期，請留意付款期限。",
      },
      hr: {
        title: "人事異動通知",
        description: "有新的員工到職資料已建立完成。",
      },
      system: {
        title: "系統維護公告",
        description: "系統將於近期進行例行維護，屆時可能短暫無法使用。",
      },
    },
  },
  employee: {
    basicInfo: "基本資訊",
    birthday: "生日",
    bloodType: "血型",
    idNumber: "身分證號",
    licenses: "駕照",
    motorcycle: "機車",
    car: "汽車",
    has: "有",
    hasNot: "沒有",
    contactAddress: "聯絡地址",
    city: "縣市",
    district: "行政區",
    postalCode: "郵遞區號",
    address: "地址",
    contactInfo: "聯絡資訊",
    email: "Email / 帳號",
    phone: "聯絡電話",
    emergencyContact: "緊急聯絡人",
    relationship: "關係",
    emergencyPhone: "緊急聯絡人電話",
    notes: "備註",
    gender: {
      male: "男生",
      female: "女生",
      unknown: "未知",
    },
    management: {
      noEmployees: "您尚未新增員工資料！你可以試試：",
      templateExcel: "範本Excel",
      manualAdd: "手動新增",
      addEmployee: "新增員工",
      searchPlaceholder: "搜尋員工...",
      errorFetchingData: "獲取公司資料時發生錯誤：",
    },
    edit: {
      title: "編輯員工",
      editTitle: "編輯 {{name}}",
      reinstate: "員工復職",
      resign: "離職",
      saveChanges: "儲存變更",
      resignedReadOnly: "此員工已離職，資料為唯讀模式。",
      subtitle: "修改員工的基本資訊。",
      basicData: "基本資料",
      confirmResignTitle: "確認是否離職",
      confirmResignContent:
        "確定要將 {{name}} 設定為離職嗎？此操作將清除該員工的所有授權。",
      confirmResignOk: "確認離職",
      bloodTypePlaceholder: "選擇血型",
      bloodTypeA: "A型",
      bloodTypeB: "B型",
      bloodTypeAB: "AB型",
      bloodTypeO: "O型",
      notesPlaceholder: "輸入備註...",
      tags: "員工標籤",
      selectExistingTag: "選擇已有標籤",
      newTagPlaceholder: "新增自訂標籤...",
      createTag: "建立",
      name: "姓名",
      gender: "性別",
      birthday: "生日",
      bloodType: "血型",
      idNumber: "身分證號",
      licenses: "駕照",
      motorcycle: "機車",
      car: "汽車",
      has: "有",
      hasNot: "沒有",
      contactAddress: "聯絡地址",
      city: "縣市",
      district: "行政區",
      postalCode: "郵遞區號",
      address: "地址",
      contactInfo: "聯絡資訊",
      email: "Email",
      emergencyContact: "緊急聯絡人",
      relationship: "關係",
      emergencyPhone: "緊急聯絡人電話",
      notes: "備註",
      save: "儲存",
      cancel: "取消",
      confirmCancel: "確定要取消嗎？",
      errorFetchingData: "獲取員工資料時發生錯誤：",
    },
    signature: {
      title: "簽名檔",
      hint: "上傳簽名照片後會自動去背，簽名檔以簽名密碼保護，僅本人可檢視。",
      selfOnly: "簽名檔僅能由員工本人登入後設定。",
      addHint: "簽名檔需由員工本人登入後，於編輯資料時設定。",
      locked: "簽名檔受密碼保護，請輸入簽名密碼檢視",
      notUploaded: "尚未上傳簽名檔。",
      view: "檢視簽名",
      upload: "上傳簽名",
      replace: "更換簽名",
      changePassword: "修改簽名密碼",
      password: "簽名密碼",
      currentPassword: "目前簽名密碼",
      newPassword: "新簽名密碼",
      confirmPassword: "確認簽名密碼",
      firstUploadHint: "第一次上傳會將此密碼設為簽名密碼；若已設定過，請輸入目前的簽名密碼。",
      oldPasswordRequired: "請輸入目前簽名密碼",
      passwordTooShort: "簽名密碼至少 {{min}} 個字元",
      passwordMismatch: "兩次輸入的密碼不一致",
      passwordIncorrect: "簽名密碼錯誤",
      passwordChanged: "簽名密碼已更新",
      forbidden: "沒有簽名檔權限",
      requestFailed: "簽名檔操作失敗，請稍後再試",
      original: "原圖",
      processed: "去背結果",
      sensitivity: "去背強度",
      processing: "處理中…",
      rotateLeft: "向左旋轉",
      rotateRight: "向右旋轉",
      inkColor: "筆跡顏色",
      inkOriginal: "原色",
      inkBlack: "黑色",
      inkBlue: "藍色",
      resetSensitivity: "恢復建議值",
      eraser: "手動擦除",
      eraserDone: "完成擦除",
      eraserHint: "用手指、觸控筆或滑鼠塗抹要清掉的雜點或陰影；調整去背強度或筆跡顏色時，擦除的區域會保留。旋轉前請先完成擦除。",
      brushSize: "筆刷大小",
      brushSmall: "小",
      brushMedium: "中",
      brushLarge: "大",
      undo: "復原",
      restoreAll: "全部還原",
      sensitivityHint: "背景沒去乾淨請調高；筆跡斷掉或變淡請調低。",
      emptyResult: "去背後沒有留下筆跡，請調低去背強度",
      invalidFile: "請選擇圖片檔",
      fileTooLarge: "圖片不可超過 10MB",
      uploadSuccess: "簽名檔已儲存",
      confirm: "確認",
      save: "儲存",
    },
    add: {
      title: "新增員工",
      cancel: "取消",
      submit: "新增",
      accountInfo: "帳號資訊",
      emailPlaceholder: "請輸入 Email",
      namePlaceholder: "請輸入姓名",
      emailRequired: "請輸入 Email",
      addFailed: "新增員工失敗",
      selectTags: "選擇標籤",
    },
    list: {
      searchPlaceholder: "搜尋員工姓名或電郵...",
      filterByTag: "篩選標籤",
      noTags: "尚無標籤",
      activeSection: "現有員工",
      noResults: "找不到符合條件的員工",
      resignedSection: "離職員工",
      noResigned: "無離職員工記錄",
    },
    page: {
      employeeListTab: "員工列表",
      permissionOverviewTab: "授權總覽",
      permissionTitle: "權限分配總覽",
      permissionHint: "點擊圖示可切換授權狀態，變更後點擊儲存按鈕保存",
      licensesTab: "授權額度",
      invoiceTab: "發票",
      invoice: {
        profileTitle: "發票資訊",
        editProfile: "編輯",
        profileNotSet: "尚未設定發票資訊，開立發票前請先填寫",
        type: "發票類型",
        types: { b2b: "三聯式（公司）", b2c: "二聯式（個人）" },
        title: "買受人抬頭",
        titleRequired: "請輸入買受人抬頭",
        taxId: "統一編號",
        taxIdInvalid: "統一編號格式不正確",
        email: "發票寄送 Email",
        emailRequired: "請輸入發票寄送 Email",
        emailInvalid: "Email 格式不正確",
        address: "寄送地址",
        historyTitle: "發票紀錄",
        empty: "尚無發票紀錄",
        number: "發票號碼",
        createdAt: "建立日期",
        item: "品項",
        seatOrderItem: "席位訂閱",
        subtotal: "未稅金額",
        tax: "稅額",
        total: "總計",
        status: "狀態",
        statuses: { pending: "待開立", issued: "已開立", void: "已作廢" },
        download: "下載發票",
      },
      pendingNotEffective: "尚未生效",
      seat: {
        pricingNote: "依席位按月計費，可自由增加或減少席位（不可低於已使用數）。",
        perSeatMonth: "/ 席・月",
        pools: {
          general: {
            name: "一般席位",
            description: "倉儲、採購、財務、採購主管、專案管理共用總席位，可自由互相調配",
          },
          projectReport: { name: "專案回報席位", description: "專案回報存取權限" },
          admin: { name: "管理員席位", description: "系統管理員權限" },
        },
        interchangeable: "（可互換）",
        allocated: "已分配",
        fullyAllocated: "席位已全部分配",
        unassigned: "尚有 {{n}} 席未分配",
        overAllocated: "已超出總數 {{n}} 席，請減少分配",
        totalSeats: "總席位數",
        standaloneTitle: "獨立席位",
        standaloneHint: "各自計費，無法與一般席位互換。",
        allocatedSeats: "分配席位",
        seatCount: "席位數",
        originalSeats: "原 {{n}} 席",
        minimum: "最少 {{n}}",
        decrease: "減少{{label}}席位",
        increase: "增加{{label}}席位",
        inputLabel: "{{label}}席位數",
        totalAfter: "調整後共 {{n}} 個席位",
        allocationOnly: "僅調整一般席位分配，費用不變",
        unassignedNotice: "一般席位尚有 {{n}} 席未分配，可先結帳，之後再分配",
        overNotice: "角色分配超出一般席位總數 {{n}} 席，請減少分配",
        monthlyAfter: "調整後每月（含稅）",
        vsCurrent: "較目前 {{amount}}",
        reset: "還原",
        checkout: "前往結帳",
        saveAllocation: "儲存分配",
        allocationSaved: "已儲存席位分配",
        confirmTitle: "確認席位調整",
        confirmDesc: "按席位計費，每月自動續訂，可隨時增減席位數。",
        plan: "席位方案",
        seats: "席位數",
        monthlyAmount: "每月金額",
        unchanged: "不變",
        originalDelta: "原 {{current}}（{{delta}}）",
        allocationChanges: "一般席位分配變更",
        subtotalSeats: "小計（{{n}} 席）",
        tax: "營業稅（{{rate}}%）",
        totalMonthly: "調整後每月應付",
        currentMonthly: "目前每月 {{amount}}",
        difference: "差額 {{amount}}",
        unassignedCheckout: "一般席位尚有 {{n}} 席未分配到角色，仍會依總數計費，結帳後可隨時再分配。",
        back: "返回修改",
        confirmCheckout: "確認結帳",
        orderCreated: "訂單已建立",
        orderId: "訂單編號",
        orderCreatedDesc: "調整後每月應付 {{amount}}。線上付款尚未開通，席位將於系統開通後生效。",
        allocationDeferred: "超出目前席位數的分配，將於席位生效後再套用。",
        done: "完成",
        pendingTitle: "待生效的席位訂單",
        pendingAllocation: "待套用分配",
        cancelOrder: "取消訂單",
        allocationExceeded: "分配加總超過席位數，只能減少分配",
        allocationBelowUsed: "分配數不可低於該角色已使用數",
        saveFailed: "儲存失敗",
      },
      subscriptionTitle: "訂閱到期日期",
      subscriptionEdit: "設定",
      subscriptionPeriod: "訂閱期間",
      subscriptionNotSet: "尚未設定訂閱期間",
      subscriptionDaysLeft: "剩餘 {{days}} 天",
      subscriptionExpired: "已到期",
      confirm: "確定",
      cancel: "取消",
      available: "可用",
      depleted: "已用完",
      usageStatus: "使用狀況",
      permissionEmployeeColumn: "員工",
      permissionRoleColumn: "身份",
      orgRoleOwner: "擁有者",
      orgRoleAdmin: "管理員",
      orgRoleMember: "成員",
      needAdminPermission: "需要管理員權限",
      quotaFull: "授權額度已達上限",
      seatQuotaFull: "席位已用完，請先增加席位或調整分配",
      clickToRevoke: "點擊取消授權",
      clickToGrant: "點擊授予權限",
      loadFailed: "載入資料失敗",
      operationFailed: "操作失敗",
      roles: {
        admin: { name: "管理員", description: "系統管理員權限" },
        project: { name: "專案管理", description: "專案管理權限" },
        projectReport: { name: "專案回報", description: "專案回報存取權限" },
        purchase: { name: "採購", description: "採購流程管理權限" },
        purchaseManager: { name: "採購主管", description: "採購單審核權限" },
        inventory: { name: "倉儲", description: "倉儲管理權限" },
        finance: { name: "財務", description: "財務資料存取權限" },
      },
    },
  },
  companyList: {
    title: "公司列表",
    backToLogin: "回到登入頁",
    selectCompany: "選擇你要開始或是檢視的公司：",
    recentlyOpened: "最近開啟",
    yourCompanies: "你的公司",
    addCompany: "你的公司",
    businessIdNumber: "統編",
  },
  productionPlan: {
    materialSpec: "材質規格-直徑-長度",
    type: "類型",
    quantity: "數量",
    material: "材質",
    unitWeight: "單位重(kg/m)",
    navigationOne: "導航一",
    navigationTwo: "導航二",
    navigationThree: "導航三",
    option1: "選項1",
    option2: "選項2",
    option3: "選項3",
    option4: "選項4",
    submenu: "子選單",
    submenu2: "子選單2",
    sortByComponentCode: "構件編號 (A-Z)",
    sortByComponentId: "構件ID (A-Z)",
    designBOM: "設計BOM",
    productionResume: "生產履歷",
    aiAssistant: "AI 助理",
    showQRCode: "顯示 qrcode",
    productionPlanTable: "生產計畫表",
    order: "訂單",
    production: "生產",
    bomTable: "BOM表",
    processSettings: "製程設定",
    sectionSpecification: "斷面規格",
    boltBOM: "螺絲BOM",
    cancel: "取消",
    ok: "確定",
  },
  textUpdateNode: {
    updateSuccess: "更新成功",
    nodeNameUpdated: "節點名稱已更新",
    updateFailed: "更新失敗",
    cannotUpdateNodeName: "無法更新節點名稱",
    workItemSettings: "工項設定",
    addWorkItem: "增加工項",
    pendingComponents: "尚等待加工構件",
    completedComponents: "已完成加工構件",
    componentList: "構件清單",
    planBom: "生產計劃BOM",
    selectComponents: "選取構件",
    manualAddComponent: "手動新增構件",
    cancel: "取消",
    confirmAdd: "確定新增",
    addNewWorkItem: "新增工項",
    workItemSelection: "工項選擇",
    enterWorkItemName: "請輸入工項名稱",
    personnelSelection: "人員選擇",
    selectPersonnel: "請選擇人員",
    scanPassCount: "掃描通過支數",
    multiple: "複數",
    single: "單支",
    all: "全部",
    selectScanPassCount: "請選擇掃描通過支數",
    addNewComponent: "新增構件",
    componentId: "構件ID",
    enterComponentId: "請輸入構件ID",
    componentCode: "構件編號",
    enterComponentCode: "請輸入構件編號",
    guandaId: "廣達ID",
    enterGuandaId: "請輸入廣達ID",
    installationLocation: "安裝位置",
    enterInstallationLocation: "請輸入安裝位置",
    installationElevation: "安裝高程",
    enterInstallationElevation: "請輸入安裝高程",
    distinction: "區別",
    enterDistinction: "請輸入區別",
    transportNumber: "拆運號碼",
    enterTransportNumber: "請輸入拆運號碼",
    transportDescription: "拆運說明",
    enterTransportDescription: "請輸入拆運說明",
    drawingName: "圖面名稱",
    enterDrawingName: "請輸入圖面名稱",
    totalWidth: "總寬度",
    enterTotalWidth: "請輸入總寬度",
    totalHeight: "總高度",
    enterTotalHeight: "請輸入總高度",
    totalLength: "總長度",
    enterTotalLength: "請輸入總長度",
    totalWeight: "總重量",
    totalWeightSingle: "總重量(單支)",
    enterTotalWeight: "請輸入總重量",
    totalArea: "總面積",
    enterTotalArea: "請輸入總面積",
    metricSizeMark: "斷面規格",
    enterMetricSizeMark: "請輸入斷面規格",
    // 錯誤處理訊息
    error: "錯誤",
    warning: "警告",
    success: "成功",
    fetchError: "載入失敗",
    createFailed: "建立失敗",
    noDocumentId: "找不到節點ID，無法更新構件清單",
    noProjectId: "找不到專案ID，無法新增構件",
    noBuildingNode: "找不到整體建築節點，無法新增構件",
    noSelectedComponents: "請至少選擇一個構件",
    componentIdRequired: "構件ID是必填欄位",
    componentCodeRequired: "構件編號是必填欄位",
    workItemNameRequired: "請輸入工項名稱",
    employeeRequired: "請至少選擇一名員工",
    noEmployeeData: "無員工資料",
    noNodeData: "無法取得節點資料",
    fetchMaterialBomError: "無法載入構件清單資料，請稍後再試",
    updateSteelAssemblyError: "無法更新構件清單，請稍後再試",
    fetchNodeDataError: "無法載入節點資料，請稍後再試",
    fetchEmployeeError: "無法載入員工資料，請稍後再試",
    fetchComponentDataError: "無法取得新增構件的詳細資料",
    createComponentError: "無法建立新構件，請稍後再試",
    addComponentError: "無法新增構件，請稍後再試",
    workItemCreateError: "無法建立工項，請稍後再試",
    componentsAddedSuccess: "構件已成功新增",
    componentAddedSuccess: "構件已成功新增",
    workItemCreatedSuccess: "工項已成功建立",
    createWorkItemError: "無法建立工項，請稍後再試",
    actions: "操作",
    remove: "移除",
    removeFailed: "移除失敗",
    componentRemovedSuccess: "構件已成功移除",
    removeSteelAssemblyError: "無法移除構件，請稍後再試",
    workerName: "施工人員",
    status: "狀態",
    reportDate: "回報日期",
    viewRecords: "查看紀錄",
    statusCompleted: "完成",
    statusError: "錯誤",
    statusNotReported: "未回報",
    showColumns: "顯示欄位",
  },
  dragDropList: {
    scanMode: "掃描模式",
    personnelSelection: "人員選擇",
    scanRecord: "掃描記錄",
    editWorkItem: "編輯工項",
    deleteWorkItem: "刪除工項",
    noScanRecord: "無掃描記錄",
    reportItems: "回報項目",
    noReportItems: "無回報項目",
    reportPerson: "回報人員",
    reportStatus: "回報狀態",
    reportComponent: "回報構件",
    reportTime: "回報時間",
    statusSuccess: "成功",
    statusError: "錯誤",
    componentsCount: "個構件",
    scanModeMultiple: "複數",
    scanModeSingle: "單支",
    scanModeAll: "全部",
    cancel: "取消",
    confirmEdit: "確定編輯",
    confirmDelete: "確定刪除",
    deleteConfirmTitle: "確認刪除工項",
    deleteConfirmMessage: "確定要刪除工項",
    workItemSelection: "工項選擇",
    enterWorkItemName: "請輸入工項名稱",
    selectPersonnel: "請選擇人員",
    scanPassCount: "掃描通過支數",
    selectScanPassCount: "請選擇掃描通過支數",
    action: "操作",
    revokeReport: "取消回報",
    revoked: "已取消",
    confirmRevoke: "確定取消回報",
    revokeConfirmTitle: "確認取消回報",
    revokeConfirmMessage:
      "確定要取消這筆回報紀錄嗎？取消後將重新計算構件狀態。",
  },
  workItemDialog: {
    createTitle: "新增工項",
    editTitle: "編輯工項",
    close: "關閉",
    workItemSelection: "工項選擇",
    enterWorkItemName: "請輸入工項名稱",
    personnelSelection: "人員選擇",
    multiSelectHint: "可複選",
    selectPersonnel: "請選擇人員",
    noPersonnel: "無可選人員",
    morePersons: "等 {{count}} 人",
    remove: "移除",
    scanPassCount: "掃描通過支數",
    scanModeMultiple: "複數",
    scanModeSingle: "單支",
    scanModeAll: "全部",
    reportItems: "回報項目",
    reportItemsHint: "選擇作業人員需回報的項目（可複選，不限數量）",
    reportItemsNote: "預設項目僅供選擇；自定義項目新增後可編輯或刪除。",
    // limitReached: "已達 {{max}} 項上限",
    addCustomItem: "新增自定義項目",
    add: "新增",
    edit: "編輯",
    delete: "刪除",
    finishEdit: "完成編輯",
    itemsSelected: "已選 {{count}} 個項目",
    cancel: "取消",
    confirmAdd: "確定新增",
    saveChanges: "儲存變更",
  },
  accountPayable: {
    title: "應付帳款",
    searchPlaceholder: "搜尋名稱、合作方、專案或備註...",
    addAccountPayable: "新增應付帳款",
    editAccountPayable: "編輯應付帳款",
    name: "名稱",
    totalAmount: "應付金額",
    unpaidAmount: "未付金額 (含稅)",
    paidAmount: "已付金額",
    status: "狀態",
    partner: "合作方",
    bank: "銀行",
    project: "專案",
    remarks: "備註",
    edit: "編輯",
    delete: "刪除",
    basicInfo: "基本資訊",
    accountPayableName: "應付帳款名稱",
    paymentStatus: "狀態",
    fullPayment: "全款",
    installPayment: "分期付款",
    partnerSupplier: "合作方/供應商",
    sourceRemarks: "來源備註",
    paymentRecord: "付款紀錄",
    addPaymentRecord: "增加付款紀錄",
    noPaymentData: "無付款資料",
    requestedAmount: "應付金額",
    taxRate: "稅率(%)",
    paymentMethod: "付款方式",
    transfer: "匯款",
    check: "支票",
    cash: "現金",
    credit: "信用卡",
    paymentDate: "付款日期",
    paymentAmount: "付款金額",
    invoiceNumber: "發票號碼",
    invoiceDate: "發票日期",
    dueDate: "到期日期",
    cancel: "取消",
    add: "新增",
    confirmDelete: "確認刪除",
    confirmDeleteContent: "確定要刪除此應付帳款嗎？此操作無法復原。",
    confirm: "確認",
    deleteSuccess: "刪除成功",
    deleteSuccessDesc: "應付帳款已成功刪除",
    deleteFailed: "刪除失敗",
    deleteError: "刪除應付帳款時發生錯誤",
    fillRequired: "請填寫必填欄位",
    missingFields: "付款紀錄 #{{number}} 缺少以下必填欄位：",
    updateDetailFailed: "更新付款明細失敗",
    createDetailFailed: "新增付款明細失敗",
    updateFailed: "更新失敗",
    createFailed: "新增應付帳款失敗",
    enterName: "請輸入名稱",
    enterPartnerName: "請輸入合作方名稱",
    records: "筆",
    clickToAddPayment: "點擊上方按鈕新增付款紀錄",
    paymentRecordNumber: "付款紀錄 #{{number}}",
    exportExcel: "匯出Excel",
    documentRecords: "文件紀錄",
    retrieved: "已取回",
    performanceGuarantee: "履約保證",
    constructionInsurance: "工程保險",
    warrantyBond: "保固本票",
    voucherNumber: "票號",
    retrievalDate: "取回日期",
    enterVoucherNumber: "請輸入票號",
    retrievedGuarantee: "已取回履約保證",
    retrievedWarrantyBond: "已取回保固本票",
    startDate: "起始日期",
    expirationDate: "到期日期",
    checkNumber: "支票號碼",
    checkClearanceDate: "兌現日期",
    handlingFee: "手續費",
    retentionAmount: "保留款",
    deductionAmount: "扣款金額",
    netAmount: "實付金額",
    totalHandlingFee: "總手續費",
    totalDeductionAmount: "總扣款金額",
    taxAmount: "稅額",
    totalAmountWithTax: "總金額（含稅)",
    isSettled: "已結清",
    totalRetentionAmount: "保留款總計",
    inProgressAmount: "進行中金額",
    selected: "已選",
  },
  accountReceivable: {
    title: "應收帳款",
    searchPlaceholder: "搜尋名稱、合作方、專案或備註...",
    addAccountReceivable: "新增應收帳款",
    editAccountReceivable: "編輯應收帳款",
    name: "名稱",
    totalAmount: "應收金額",
    unpaidAmount: "未收金額 (含稅)",
    paidAmount: "已收金額",
    totalRetentionAmount: "保留款總計",
    inProgressAmount: "進行中金額",
    status: "狀態",
    partner: "合作方",
    bank: "銀行",
    project: "專案",
    remarks: "備註",
    edit: "編輯",
    delete: "刪除",
    basicInfo: "基本資訊",
    accountReceivableName: "應收帳款名稱",
    paymentStatus: "狀態",
    fullPayment: "全款",
    installPayment: "分期付款",
    partnerSupplier: "合作方/供應商",
    sourceRemarks: "來源備註",
    collectionRecord: "收款紀錄",
    addCollectionRecord: "增加收款紀錄",
    noCollectionData: "無收款資料",
    collectionDate: "收款日期",
    collectionAmount: "收款金額",
    invoiceNumber: "發票號碼",
    invoiceDate: "發票日期",
    dueDate: "到期日期",
    cancel: "取消",
    requestedAmount: "應收金額",
    taxRate: "稅率(%)",
    paymentMethod: "付款方式",
    transfer: "匯款",
    check: "支票",
    cash: "現金",
    credit: "信用卡",
    confirmDelete: "確認刪除",
    confirmDeleteContent: "確定要刪除此應收帳款嗎？此操作無法復原。",
    confirm: "確認",
    deleteSuccess: "刪除成功",
    deleteSuccessDesc: "應收帳款已成功刪除",
    deleteFailed: "刪除失敗",
    requiredFields: "請填寫必填欄位",
    collectionRecordMissingDesc: "收款紀錄 #{{index}} 缺少以下必填欄位：",
    listSeparator: "、",
    updateDetailFailed: "更新收款明細失敗",
    addDetailFailed: "新增收款明細失敗",
    updateFailed: "更新失敗",
    records: "筆",
    clickToAddRecord: "點擊上方按鈕新增收款紀錄",
    collectionRecordLabel: "收款紀錄 #",
    enterName: "請輸入名稱",
    enterPartner: "請輸入合作方名稱",
    enterRemarks: "備註",
    exportExcel: "匯出Excel",
    filterByDate: "篩選收款日期",
    startDate: "開始日期",
    endDate: "結束日期",
    documentRecords: "文件紀錄",
    retrieved: "已取回",
    performanceGuarantee: "履約保證",
    constructionInsurance: "工程保險",
    warrantyBond: "保固本票",
    voucherNumber: "票號",
    retrievalDate: "取回日期",
    enterVoucherNumber: "請輸入票號",
    retrievedGuarantee: "已取回履約保證",
    retrievedWarrantyBond: "已取回保固本票",
    expirationDate: "到期日期",
    checkNumber: "支票號碼",
    checkClearanceDate: "兌現日期",
    handlingFee: "手續費",
    retentionAmount: "保留款",
    deductionAmount: "扣款金額",
    netAmount: "實收金額",
    totalHandlingFee: "總手續費",
    totalDeductionAmount: "總扣款金額",
    taxAmount: "稅額",
    totalAmountWithTax: "總金額（含稅)",
    isSettled: "已結清",
    selected: "已選",
  },
  bank: {
    title: "銀行",
    addBank: "新增銀行",
    editBank: "編輯銀行",
    name: "銀行名稱",
    bankName: "銀行名稱",
    balance: "餘額",
    remarks: "備註",
    edit: "編輯",
    confirm: "確認",
    cancel: "取消",
    requiredField: "請填寫必填欄位",
    nameRequired: "銀行名稱為必填",
    addSuccess: "新增成功",
    bankAdded: "銀行已新增",
    updateSuccess: "更新成功",
    bankUpdated: "銀行資料已更新",
    addFailed: "新增失敗",
    updateFailed: "更新失敗",
    enterBankName: "請輸入銀行名稱",
    enterBalance: "請輸入餘額",
    enterRemarks: "請輸入備註",
  },
  bankManagement: {
    title: "銀行管理",
    addBankNode: "新增銀行節點",
    selectBank: "選擇銀行",
    addReceivable: "新增應收",
    addPayable: "新增應付",
    selectReceivable: "選擇應收帳款",
    selectPayable: "選擇應付帳款",
    noData: "無資料",
    receivable: "應收",
    payable: "應付",
    income: "收入",
    expense: "支出",
    cancel: "取消",
    confirm: "確認",
    insufficientBalance: "餘額不足",
  },
  designBOM: {
    validationError: "資料格式錯誤",
    uploadSuccess: "成功匯入 {{count}} 筆設計BOM資料",
    uploadError: "上傳過程中發生錯誤，請稍後再試",
    componentId: "構件ID",
    guandaId: "廣達ID",
    componentCode: "構件編號",
    installationLocation: "安裝位置",
    installationElevation: "安裝高程",
    distinction: "區別",
    transportNumber: "拆運號碼",
    transportDescription: "拆運說明",
    drawingName: "圖面名稱",
    model3d: "3D圖",
    view3d: "3D 檢視",
    pick3dFile: "選檔",
    totalWidth: "總寬度",
    totalHeight: "總高度",
    totalLength: "總長度",
    totalWeight: "總重量",
    totalArea: "總面積",
    sectionSpecification: "斷面規格",
    cancel: "取消",
    save: "儲存",
    edit: "編輯",
    deleteSelected: "刪除勾選的項目",
    exportGuandaId: "匯出廣達ID",
    uploadIfc: "上傳ifc檔",
    uploadIfcSuccess: "IFC 上傳成功",
    uploadIfcError: "IFC 上傳失敗",
    projectNotFound: "找不到這個構件所屬的專案",
    ifcAnalyzing: "IFC 分析中…",
    ifcAnalyzed: "IFC 分析完成",
    ifcAnalyzeFailed: "IFC 分析失敗",
    importComponent: "匯入構件",
    manualAddBOM: "手動新增構件",
    summaryCompact: "已選 {{selected}} / {{total}}",
    summaryTotal: "本專案共 {{count}} 隻",
    summarySelected: "已選擇 {{count}} 隻",
    summaryWeight: "總重量 {{weight}} kg",
    searchGuandaId: "搜尋廣達ID",
    searchComponentCode: "搜尋構件編號",
    searchDistinction: "搜尋區別",
    searchTransportNumber: "搜尋拆運號碼",
    searchSectionSpec: "搜尋斷面規格",
    search: "搜尋",
    clear: "清除",
    editSuccess: "編輯成功",
    editFailed: "編輯失敗",
    deleteSuccess: "刪除成功",
    noItemsToDelete: "請勾選需要刪除的項目",
    noChangesToUpdate: "沒有修改可以更新",
    parameterSettings: "參數設定",
    download: "下載",
    paramA: "參數A - 車次",
    paramB: "參數B - 構件編號",
    paramC: "參數C",
    option1: "選項1",
    option2: "選項2",
    option3: "選項3",
    option4: "選項4",
    option5: "選項5",
    none: "無",
    train: "車次",
    character: "字元",
    enterCharacter: "輸入字元",
    printQRCode: "印出QR Code",
    notPrintQRCode: "不印出QR Code",
    shouldPrintQRCode: "是否要印出QR Code",
    noData: "無資料",
    downloadFailed: "下載失敗",
    cannotFetchData: "無法獲取所有資料，請稍後再試",
    manualAddBOMTitle: "手動新增構件",
    add: "新增",
    enterComponentId: "請輸入構件ID",
    enterComponentCode: "請輸入構件編號",
    enterInstallationLocation: "請輸入安裝位置",
    enterInstallationElevation: "請輸入安裝高程",
    enterDistinction: "請輸入區別",
    enterTransportNumber: "請輸入拆運號碼",
    enterTransportDescription: "請輸入拆運說明",
    enterDrawingName: "請輸入圖面名稱",
    enterTotalWidth: "請輸入總寬度",
    enterTotalHeight: "請輸入總高度",
    enterTotalLength: "請輸入總長度",
    enterTotalWeight: "請輸入總重量",
    enterTotalArea: "請輸入總面積",
    enterSectionSpec: "請輸入斷面規格",
    manualAddSuccess: "手動新增構件成功",
    manualAddFailed: "手動新增構件失敗，請檢查輸入資料",
    manualAddError: "手動新增構件失敗，請稍後再試",
    showColumns: "顯示欄位",
    showAllColumns: "顯示全部",
    hideAllColumns: "全部隱藏",
    exportFailed: "匯出失敗",
    noItemsToExport: "請先勾選需要匯出的項目",
  },
  steelAssemblyBOM: {
    uploadSuccess: "成功匯入 {{count}} 筆鋼構組立BOM資料",
    uploadPartialError: "上傳失敗：{{failed}} 筆資料無法儲存，成功：{{success}} 筆",
    uploadError: "上傳過程中發生錯誤，請稍後再試",
    title: "鋼構件 BOM",
    showColumns: "顯示欄位",
    componentId: "構件ID",
    guandaId: "廣達ID",
    componentCode: "構件編號",
    installationLocation: "安裝位置",
    installationElevation: "安裝高程",
    distinction: "區別",
    transportNumber: "拆運號碼",
    transportDescription: "拆運說明",
    drawingName: "圖面名稱",
    totalWidth: "總寬度",
    totalHeight: "總高度",
    totalLength: "總長度",
    totalWeight: "總重量",
    totalArea: "總面積",
    sectionSpecification: "斷面規格",
    cancel: "取消",
    save: "儲存",
    edit: "編輯",
    deleteSelected: "刪除勾選的項目",
    importComponent: "匯入構件",
    searchGuandaId: "搜尋廣達ID",
    searchInstallationLocation: "搜尋安裝位置",
    searchSectionSpec: "搜尋斷面規格",
    searchTransportNumber: "搜尋拆運號碼",
    search: "搜尋",
    clear: "清除",
    editSuccess: "編輯成功",
    editFailed: "編輯失敗",
    deleteSuccess: "刪除成功",
    noItemsToDelete: "請勾選需要刪除的項目",
    backToDesignBOM: "回到設計BOM",
    errorFetchingData: "獲取鋼構件資料時發生錯誤：",
    errorUpdatingData: "更新鋼構件資料時發生錯誤：",
    errorDeletingData: "刪除鋼構件資料時發生錯誤：",
    successUpdate: "更新成功",
    successDelete: "刪除成功",
  },
  steelBoltBOM: {
    uploadSuccess: "成功匯入 {{count}} 筆鋼栓BOM資料",
    uploadPartialError: "上傳失敗：{{failed}} 筆資料無法儲存，成功：{{success}} 筆",
    uploadError: "上傳過程中發生錯誤，請稍後再試",
    partNumber: "零件編號",
    partName: "零件名稱",
    material: "材質",
    specification: "規格",
    quantity: "數量",
    unit: "單位",
    weight: "重量",
    remarks: "備註",
    cancel: "取消",
    save: "儲存",
    edit: "編輯",
    delete: "刪除",
    deleteSelected: "刪除勾選的項目",
    importPart: "匯入零件",
    search: "搜尋",
    clear: "清除",
    editSuccess: "編輯成功",
    editFailed: "編輯失敗",
    deleteSuccess: "刪除成功",
    noItemsToDelete: "請勾選需要刪除的項目",
    searchPartNumber: "搜尋零件編號",
    searchPartName: "搜尋零件名稱",
    searchMaterial: "搜尋材質",
    searchSpecification: "搜尋規格",
    showColumns: "顯示欄位",
  },
  coop: {
    companyName: "公司名",
    businessIdNumber: "統編",
    contactPerson: "聯絡人",
    phone: "電話",
    email: "E-mail",
    basicInfo: "基本資訊",
    contactInfo: "聯絡資訊",
    address: "地址",
    city: "縣市",
    district: "行政區",
    postalCode: "郵遞區號",
    fullAddress: "完整地址",
    businessType: "營業項目",
    representative: "負責人",
    capital: "資本額",
    establishedDate: "成立日期",
    website: "網站",
    notes: "備註",
    status: "狀態",
    active: "啟用",
    inactive: "停用",
    pending: "審核中",
    reviewed: "已審核",
    management: "合作方管理",
    list: "合作方列表",
    add: "新增合作方",
    edit: "編輯合作方",
    view: "查看合作方",
    delete: "刪除合作方",
    search: "搜尋合作方",
    searchPlaceholder: "搜尋公司名稱、統編或聯絡人...",
    activeSection: "合作方",
    pendingSection: "審核中合作方",
    noResults: "找不到符合條件的合作方",
    noPending: "無審核中合作方",
    addNew: "新增合作方",
    editTitle: "編輯合作方資訊",
    viewTitle: "合作方詳細資訊",
    pendingManagement: "審核中合作方",
    reviewedManagement: "已停用合作方",
    actions: "操作",
    approve: "審核通過",
    reject: "駁回",
    reactivate: "重新啟用",
    deactivate: "停用",
    confirmDelete: "確定要刪除此合作方嗎？",
    confirmDeactivate: "確定要停用此合作方嗎？",
    confirmReactivate: "確定要重新啟用此合作方嗎？",
    deleteSuccess: "合作方刪除成功",
    deactivateSuccess: "合作方停用成功",
    reactivateSuccess: "合作方重新啟用成功",
    saveSuccess: "合作方資訊儲存成功",
    errorFetchingData: "獲取合作方資料時發生錯誤",
    errorSavingData: "儲存合作方資料時發生錯誤",
    errorDeletingData: "刪除合作方資料時發生錯誤",
    requiredField: "此欄位為必填",
    invalidEmail: "請輸入有效的電子郵件地址",
    invalidPhone: "請輸入有效的電話號碼",
    abbreviation: "簡稱",
    contactAddress: "聯絡地址",
    businessRegisterAddress: "1. 營業登記地址",
    invoiceAddressSection: "2. 發票地址",
    shippingAddressSection: "3. 送貨地址",
    sameAsBusinessAddress: "同營業登記地址",
    sameAsInvoiceAddress: "同發票地址",
    basicContactInfo: "1. 基本聯絡資訊",
    fax: "傳真",
    contactPersonInfo: "2. 聯絡人資訊",
    department: "部門",
    invoiceType: "發票種類",
    cancel: "取消",
    confirm: "確定",
    addBtn: "新增",
    noPendingData: "您尚未有審核中的資料",
    noReviewedData: "您尚未有已停用的資料",
    backToPartnerList: "回到合作方列表",
    backToDetail: "回到合作方詳細資訊",
    editLockedTitle: "無法編輯合作方",
    editLockedPending: "此合作方正在停用審核中，無法編輯資料。",
    editLockedDisabled: "此合作方已停用，無法編輯資料。",
    createSuccess: "建立合作方成功！",
    addContact: "新增聯絡人",
    removeContact: "移除聯絡人",
    contactNumber: "聯絡人 #{{number}}",
    noContacts: "尚未新增聯絡人",
  },
  purchaseOrder: {
    name: "名稱",
    purchaseOrderName: "採購單名稱",
    date: "日期",
    purchaseDate: "採購日期",
    deliveryDate: "交貨日期",
    partner: "合作方",
    customer: "合作方（客戶）",
    supplier: "供應商",
    remarks: "備註",
    address: "地址",
    deliveryAddress: "交貨地址",
    city: "縣市",
    district: "行政區",
    postalCode: "郵遞區號",
    fullAddress: "完整地址",
    basicInfo: "基本資訊",
    contactInfo: "聯絡資訊",
    management: "採購單管理",
    draftManagement: "採購單草稿管理",
    underReviewManagement: "審核中採購單",
    approvedManagement: "已審核採購單",
    completedManagement: "已完成採購單",
    rejectedManagement: "已駁回採購單",
    list: "採購單列表",
    add: "新增採購單",
    edit: "編輯採購單",
    view: "查看採購單",
    delete: "刪除採購單",
    draft: "草稿",
    underReview: "審核中",
    approved: "已審核",
    completed: "已完成",
    rejected: "已駁回",
    status: "狀態",
    reviewStatus: "審核狀態",
    actions: "操作",
    approve: "審核通過",
    reject: "駁回",
    submit: "提交審核",
    save: "儲存",
    cancel: "取消",
    create: "建立",
    update: "更新",
    searchPlaceholder: "搜尋採購單名稱或供應商...",
    totalAmount: "總金額",
    quantity: "數量",
    unitPrice: "單價",
    productName: "商品名稱",
    productCode: "商品編號",
    specifications: "規格",
    unit: "單位",
    confirmDelete: "確定要刪除此採購單嗎？",
    confirmSubmit: "確定要提交此採購單進行審核嗎？",
    confirmApprove: "確定要審核通過此採購單嗎？",
    confirmReject: "確定要駁回此採購單嗎？",
    saveSuccess: "採購單儲存成功",
    createSuccess: "採購單建立成功",
    updateSuccess: "採購單更新成功",
    deleteSuccess: "採購單刪除成功",
    submitSuccess: "採購單提交審核成功",
    approveSuccess: "採購單審核通過",
    rejectSuccess: "採購單已駁回",
    errorFetchingData: "獲取採購單資料時發生錯誤",
    errorSavingData: "儲存採購單資料時發生錯誤",
    errorDeletingData: "刪除採購單資料時發生錯誤",
    requiredField: "此欄位為必填",
    invalidAmount: "請輸入有效的金額",
    invalidQuantity: "請輸入有效的數量",
    noPurchaseOrderData: "您尚未新增採購單資料！你可以試試：",
    manualAdd: "手動新增",
    createPurchaseOrder: "建立採購單",
    paymentMethod: "付款方式",
    shippingFeeCalculation: "運費計算方式",
    actualShippingFee: "實際運費",
    orderReminderDate: "設定下單提醒",
    requiresInvoice: "是否開發票",
    requiresIncomingQualityControl: "是否要進料檢",
    incomingQCItems: "進料檢項目",
    addFile: "新增檔案",
    product: "商品",
    addProductRow: "增加商品列",
    productNameCode: "商品名稱 / 編號",
    delete: "刪除",
    deliverySettings: "交貨設定",
    deliveryMethodSection: "1. 交貨方式",
    deliveryMethodTitle: "交貨方式",
    deliveryMethodLabel: "交貨方式＊",
    deliveryReceiver: "交貨簽收人員",
    deliveryLocation: "2. 交貨地點",
    deliveryLocationTitle: "交貨地點",
    deliveryLocationPlaceholder: "請輸入交貨地點",
    remarkNoticeTitle: "備註與注意事項",
    remark: "備註",
    remarkPlaceholder: "請輸入備註",
    notice: "注意事項",
    noticePlaceholder: "請輸入注意事項",
    subtotal: "小計",
    print: "列印",
    printTitle: "採購單",
    printItemNo: "項次",
    printWeight: "重量(kg)",
    printContact: "聯絡人",
    printTelephone: "電話",
    printFax: "傳真",
    printAmountSubtotal: "數量小計",
    printWeightSubtotal: "重量小計",
    printGrandTotal: "金額總計",
    printNoticeTitle: "【注意事項】",
    printFinance: "財務",
    printApprover: "審核",
    printApplicant: "申請人",
    createAndSubmit: "建立並送審",
    createOrderSuccess: "建立採購單成功！",
    confirm: "確定",
    freeShipping: "免運費",
    shippingFeeRequired: "加付運費",
    singleDelivery: "一次到貨",
    partialDelivery: "分批出貨",
    yes: "是",
    no: "不是",
    purchaseDateError: "採購日期不能晚於交貨日期",
    productListItemsRequired: "商品列欄位為必填",
    createFailed: "創建採購單失敗",
    reviewApplication: "審核申請",
    applicant: "申請人",
    applicationDate: "申請時間",
    reviewer: "審核人",
    reviewDate: "審核時間",
    pendingAfterSubmit: "送審後產生",
    pendingAfterReview: "審核後產生",
    applicantPending: "（待送審）",
    saveFailed: "儲存採購單失敗",
    rejectAction: "審核不通過",
    rejectReason: "審核不通過原因",
    rejectReasonRequired: "請填寫審核不通過原因",
    submitReject: "送出",
    resubmit: "重新送審",
    complete: "完成",
    completeSuccess: "採購單已完成",
    completeFailed: "採購單完成失敗",
    submitFailed: "採購單送審失敗",
    approveFailed: "採購單審核失敗",
    rejectFailed: "採購單駁回失敗",
    reviewNotPassed: "審核未通過",
    reviewPassed: "已通過",
    noApprovePermission: "您沒有採購審核權限，請聯絡採購主管",
  },
  stockRequest: {
    title: "領料單管理",
    stockRequestManagement: "領料單管理",
    stockRequestList: "領料單清單",
    stockRequestDoc: "領料單",
    editStockRequest: "編輯領料單",
    closeOrder: "結案",
    productCode: "商品編號",
    productName: "商品名稱",
    noStockRequestData: "您尚未建立領料單資料！你可以試試：",
    manualAdd: "手動新增",
    stockRequestName: "領料單名稱",
    requestPerson: "領料人員",
    outboundStaff: "出庫人員",
    createdTime: "建立時間",
    createStockRequest: "建立領料單",
    basicInfo: "基本資訊",
    productList: "商品清單",
    addProductRow: "增加商品列",
    productNameCode: "商品名稱 / 編號",
    warehouseLabel: "倉庫",
    areaLabel: "區",
    storageLocationLabel: "儲位",
    quantity: "數量",
    delete: "刪除",
    deliveryInfo: "交貨資訊",
    deliveryPerson: "送貨人員",
    inboundStaff: "入庫人員",
    remarks: "備註",
    cancel: "取消",
    create: "建立",
    submitEdit: "送出編輯",
    stockRequestCreatedSuccess: "建立領料單成功！",
    confirm: "確定",
    productListMinOne: "商品清單最少要有一列",
    ensureProductComplete: "請確保所有商品都已選擇產品、儲位和數量",
    selectProductFromList: "請從下拉選單中選擇商品，不可自行輸入",
    selectStorageFromList: "請從下拉選單中選擇儲位，不可自行輸入",
  },
  warehouse: {
    deleteArea: "刪除區域",
    name: "名稱",
    warehouseName: "倉庫名稱",
    date: "日期",
    partner: "合作方",
    customer: "合作方（客戶）",
    remarks: "備註",
    address: "地址",
    warehouseAddress: "倉庫地址",
    city: "縣市",
    district: "行政區",
    postalCode: "郵遞區號",
    fullAddress: "完整地址",
    basicInfo: "基本資訊",
    contactInfo: "聯絡資訊",
    description: "描述",
    warehouseDescription: "倉庫描述",
    contactPerson: "聯絡人",
    phone: "電話",
    email: "E-mail",
    management: "倉庫管理",
    warehouseManagement: "倉庫與儲位管理",
    storageLocationManagement: "儲位管理",
    list: "倉庫列表",
    add: "新增倉庫",
    edit: "編輯倉庫",
    view: "查看倉庫",
    delete: "刪除倉庫",
    save: "儲存",
    cancel: "取消",
    create: "建立",
    update: "更新",
    searchPlaceholder: "搜尋倉庫名稱或地址...",
    storageLocation: "儲位",
    storageLocationSection: "儲存位置",
    storageLocationName: "儲位名稱",
    capacity: "容量",
    currentStock: "目前庫存",
    availableSpace: "可用空間",
    status: "狀態",
    active: "啟用",
    inactive: "停用",
    actions: "操作",
    confirmDelete: "確定要刪除此倉庫嗎？",
    saveSuccess: "倉庫資訊儲存成功",
    createSuccess: "倉庫建立成功",
    updateSuccess: "倉庫更新成功",
    deleteSuccess: "倉庫刪除成功",
    errorFetchingData: "獲取倉庫資料時發生錯誤",
    errorSavingData: "儲存倉庫資料時發生錯誤",
    errorDeletingData: "刪除倉庫資料時發生錯誤",
    requiredField: "此欄位為必填",
    invalidAddress: "請輸入有效的地址",
    inventoryManagement: "入庫單管理",
    stockRequestManagement: "領料單管理",
    inventoryCreated: "已建立",
    inventoryCompleted: "已完成",
    stockRequestCreated: "已建立",
    stockRequestCompleted: "已完成",
    productManagement: "商品管理",
    productName: "商品名稱",
    productNameDuplicate: "此合作方已有相同商品名稱，請使用其他名稱",
    partnerLockedReferenced: "此商品已被採購／入庫／領料單引用，無法變更合作方",
    filterByPartner: "篩選合作方",
    noPartnerFound: "查無合作方",
    productCode: "商品編號",
    productDescription: "商品描述",
    productImage: "商品圖片",
    uploadImage: "點擊上傳圖片",
    imageUploading: "圖片上傳中...",
    imageUploadError: "圖片上傳失敗",
    productType: "商品類型",
    selectItem: "選擇品項",
    selectCategory: "選擇品項分類",
    selectSteelType: "選擇型鋼類型",
    autoCalculated: "自動計算",
    itemSource: "品項來源",
    companyItem: "公司品項",
    defaultItem: "預設品項",
    itemCategory: "品項分類",
    steelItemType: "型鋼類型",
    screwItemType: "螺絲類型",
    generalType: "通用",
    steelType: "鋼材",
    steelCategory: "類型",
    sectionDimension: "斷面規格",
    material: "材質",
    length: "長度",
    unitQuantity: "單位量",
    unitWeight: "單位重(kg/m)",
    weight: "重量",
    specifications: "規格",
    unit: "單位",
    quantity: "數量",
    storageSpot: "儲位",
    amount: "數量",
    inventoryLowerLimit: "設定庫存下限",
    inventoryLowerLimitContact: "庫存下限通知人",
    addProductRow: "增加商品列",
    createProduct: "建立商品",
    editProduct: "編輯商品",
    productCreateSuccess: "建立倉儲成功！",
    unitPrice: "單價",
    totalAmount: "總金額",
    supplier: "供應商",
    deliveryPerson: "送貨人員",
    licensePlateNumber: "送貨車牌",
    warehouseStaff: "倉庫人員",
    inboundStaff: "入庫人員",
    outboundStaff: "出庫人員",
    shippingLocation: "出貨地點",
    deliveryDate: "交貨日期",
    receivedDate: "收貨日期",
    requestDate: "申請日期",
    completedDate: "完成日期",
    enable: "是否啟用",
    enabledValue: "是",
    disabledValue: "否",
    warehouseDescriptionLabel: "倉庫描述",
    storageLocationSection: "倉庫儲位",
    addStorage: "新增儲位",
    editBtn: "編輯",
    deleteBtn: "刪除",
    noEmployeeData: "暫無員工資料可供選擇",
    selectContact: "請選擇聯絡人",
    createWarehouse: "新增倉庫",
    confirm: "確定",
    fieldDescription: "欄位描述",
    warehouseCreatedSuccess: "建立倉儲成功！",
    stockReceiptName: "入庫單名稱",
    createStockReceipt: "建立入庫單",
    stockReceiptManagement: "入庫單管理",
    stockReceiptList: "入庫單清單",
    editStockReceipt: "編輯入庫單",
    noStockReceiptData: "您尚未建立入庫單資料！你可以試試：",
    noStockReceiptDoneData: "尚無已完成入庫單資料",
    stockReceiptDoneManagement: "入庫單總表",
    stockReceiptDoneList: "已完成入庫單清單",
    createdTime: "建立時間",
    closeOrder: "結案",
    productList: "商品清單",
    productNameCode: "商品名稱 / 編號",
    warehouseLabel: "倉庫",
    areaLabel: "區",
    storageLocationLabel: "儲位",
    deliveryInfo: "交貨資訊",
    stockReceiptCreatedSuccess: "建立入庫單成功！",
    productListMinOne: "商品清單最少要有一列",
    ensureProductComplete: "請確保每個商品都選擇了產品、儲位和數量",
    selectProductFromList: "請從下拉選單中選擇商品，不可自行輸入",
    selectStorageFromList: "請從下拉選單中選擇儲位，不可自行輸入",
    warehouseArea: "倉庫區域",
    areaSection: "倉庫區域",
    areaName: "區域名稱",
    addArea: "新增區域",
    editArea: "編輯區域",
    areaDescription: "區域描述",
    noAreaYet: "尚未新增倉庫區域",
    deleteAreaConfirm: "確定要刪除此區域嗎？此區域下的儲位也會一併刪除。",
    picture: "圖片",
    pictureUrlPlaceholder: "圖片網址",
    storageLocationCount: "儲位數量",
    selectWarehouse: "選擇倉庫",
    selectWarehousePrompt: "請先選擇倉庫以編輯配置圖",
    saveLayout: "儲存配置",
    saving: "儲存中…",
    layoutSaved: "配置已儲存",
    layoutSaveError: "配置儲存失敗",
    loadLayoutError: "載入倉庫配置失敗",
    itemSaveError: "商品儲存失敗",
    itemDeleteError: "商品刪除失敗",
    renameError: "重新命名失敗",
    openManagementSystem: "進入倉儲管理系統",
  },
  stockHistory: {
    title: "進出貨歷程",
    subtitle: "點擊貨物即可查看每筆入庫與領料的時間與數量",
    totalItems: "貨物品項",
    totalIn: "累計進貨",
    totalOut: "累計出貨",
    goodsList: "貨物清單",
    searchPlaceholder: "搜尋商品名稱",
    perPage: "每頁筆數",
    pageLabel: "頁次",
    prevPage: "上一頁",
    nextPage: "下一頁",
    colProduct: "商品",
    colLocation: "倉庫 / 儲位",
    colIn: "進貨",
    colOut: "出貨",
    colStock: "目前庫存",
    locationUnit: "儲位",
    stockLabel: "庫存",
    statusOut: "缺貨",
    statusLow: "低庫存",
    statusNormal: "正常",
    loading: "載入中…",
    noResult: "找不到符合的貨物",
    drawerLabel: "貨物進出歷程",
    close: "關閉",
    stockDistribution: "庫存分佈",
    locationCount: "個儲位",
    locationColumn: "倉庫 / 區 / 儲位",
    noLocation: "尚無儲位資料",
    allLocations: "全部儲位",
    noMovement: "尚無進出貨紀錄",
    noMovementForLocation: "此儲位沒有進出紀錄",
    docTypeIn: "入庫單",
    docTypeOut: "領料單",
    deliveryPerson: "送貨人員",
    pickupPerson: "領料/出庫",
    warehouseLabel: "倉庫",
    areaSuffix: "區",
  },
  pdfPreview: {
    title: "圖面預覽",
    openInNewTab: "在新分頁開啟",
    close: "關閉",
    notFound: "找不到對應的 PDF 圖面",
  },
  ifcViewer: {
    title: "3D 圖面預覽",
    close: "關閉",
    pickFile: "選擇本機 .ifc 檔",
    notFound: "這個專案還沒有 IFC 分析結果",
    loading: "3D 模型載入中…",
    analyzing: "本機 IFC 分析中…",
    empty: "這個 IFC 檔沒有可顯示的幾何",
    noMatch: "這個 IFC 檔裡找不到對應的構件",
    sharedMark: "同編號共 {{count}} 支，這裡顯示其中 1 支",
    error: "3D 模型載入失敗",
    resetView: "重設視角",
  },
  rfq: {
    addLine: {
      title: "新增詢價明細",
      description: "明細一律從既有商品選取，品名與規格由商品帶出。",
      search: "搜尋品名 / 規格 / 材質",
      noProduct: "查無商品。",
      selected: "已選 {{n}} 項",
      empty: "左側點選商品後，在這裡設定數量與交期。",
      remove: "移除",
      cancel: "取消",
      confirm: "新增 {{n}} 筆",
    },
    list: {
      create: "新增詢價單",
      search: "搜尋單號 / 標題 / 承辦",
      allStatus: "全部狀態",
      empty: "尚無詢價單，點「新增詢價單」開始。",
      colCode: "詢價單號",
      colName: "案件名稱",
      colIssueDate: "發出日期",
      colDeliveryLocation: "交貨地點",
      colApplicant: "承辦採購",
      colStatus: "狀態",
      cancel: "取消",
      confirmCreate: "建立",
    },
    unsupportedField: "後端尚未提供此欄位，暫時無法儲存",
    loadFailed: "載入詢價單失敗",
    actionFailed: "操作失敗",
    createFailed: "建立詢價單失敗",
    notFound: "找不到此詢價單",
    backToList: "回詢價單列表",
    statusNoticeInquiring: "詢價中 — 可調整主檔、明細、廠商與決標",
    statusNoticeLocked: "非詢價中狀態 — 主檔、明細與決標唯讀",
    voidDisabled: "後端未提供作廢狀態，暫不支援",
    reviewHint: "請至「廠商與比價」分頁核准或駁回",
    title: "詢價單",
    roleManager: "採購主管視角",
    roleBuyer: "採購承辦視角",
    statusNotice: "比價中 — 主檔唯讀，可調整明細與決標",
    saveDraft: "儲存草稿",
    saveDraftDisabled: "比價中，主檔唯讀",
    void: "作廢",
    tabDetail: "明細",
    tabPricing: "廠商與比價",
    tabHistory: "歷程",
    status: {
      draft: "草稿",
      inquiring: "詢價中",
      comparing: "比價中",
      pendingReview: "待主管審核",
      awarded: "已決標",
      voided: "作廢",
    },
    category: {
      material: "材料",
      fabrication: "工廠加工製作",
      surface: "表面處理",
      bolt: "螺栓/續接器",
      transport: "運輸/吊裝",
      other: "其他",
    },
    priceMode: {
      weight: "重量 (元/kg)",
      unit: "單位",
    },
    reply: {
      pending: "未回覆",
      quoted: "已收到報價",
      declined: "婉拒",
      overdue: "逾期未回",
    },
    attachKind: {
      drawing: "圖說",
      spec: "規範",
      material: "材質要求",
      other: "其他",
    },
    awardReason: {
      dueDate: "交期無法配合",
      quality: "品質履約紀錄不良",
      capacity: "產能不足",
      noMtc: "無材證能力",
      altMaterial: "材質需替代",
      payment: "付款條件差異",
      other: "其他",
    },
    info: {
      edit: "編輯",
      save: "儲存",
      cancel: "取消",
      remark: "備註",
      reviewer: "審核主管",
      reviewDate: "審核日期",
      requireDateHint: "需求交期改為逐項設定，請於明細頁調整",
      sectionTitle: "詢價單資訊",
      collapse: "收合",
      expand: "展開",
      no: "詢價單號",
      title: "詢價標題",
      project: "專案",
      contract: "合約書編號",
      issueDate: "發出日期",
      deadline: "報價截止時間",
      deliverTo: "交貨地點",
      requireDate: "需求交期",
      paymentTerms: "我方付款條件",
      priceBasis: "價格基準",
      priceBasisDap: "送達工地 DAP",
      priceBasisExw: "出廠價 EXW",
      budget: "預算總額 (目標單價加總)",
      buyer: "承辦採購",
      categories: "包含類別",
      sourcePo: "來源採購單",
      attachments: "附件（圖說 / 規範 / 材質要求）",
      addAttachment: "新增附件",
      noAttachment: "尚無附件，點「新增附件」上傳圖說、規範或材質要求。",
      download: "下載",
      remove: "移除",
    },
    detail: {
      categoryFieldsDisabled: "後端未提供類別明細欄位，暫時無法編輯",
      footerServer: "共 {{total}} 筆明細。品名、規格、單位由商品帶出唯讀，數量與交期可調整。",
      sectionTitle: "詢價明細",
      empty: "尚無明細，先從採購單帶入項目。",
      importFromPo: "從採購單帶入",
      viewSeq: "依項次",
      viewGroup: "依規格分組",
      deleteSelected: "刪除選取",
      addManual: "手動新增",
      colSeq: "項次",
      colName: "品名",
      colCategory: "類別",
      colSpec: "規格",
      colQty: "詢價數量",
      colUnit: "單位",
      colPriceMode: "比價模式",
      colCategoryFields: "類別明細",
      colWeight: "總重 (kg)",
      colDueDate: "需求交期",
      colMtc: "材證",
      colTargetPrice: "目標單價",
      colNote: "備註",
      autoWeight: "自動試算",
      noWeight: "缺規格，無法試算",
      unitPriced: "—（單位計價）",
      sourceQty: "來源 {{qty}}",
      sourceMark: "來源 {{po}} ・ 項次 {{seq}}",
      manualMark: "手動新增",
      newItem: "新項目",
      noExtraField: "此類別無額外欄位",
      unitWeightHint: "單位重 {{value}} kg/m",
      groupSummary: "・{{n}} 項 ・ 合計數量 {{qty}} ・ 總重 {{weight}} kg",
      footer: "共 {{total}} 筆明細 ・ 帶入 {{po}} ・ 手動 {{manual}}。規格由採購單帶入者唯讀，數量可調整。",
      fieldMaterial: "材質",
      fieldSectionType: "斷面型式",
      fieldNominalSpec: "標稱規格",
      fieldLength: "長度(mm)",
      fieldCount: "支/張數",
      fieldMemberType: "構件類別",
      fieldWeldGrade: "銲道等級",
      fieldNeedUt: "需 UT",
      fieldUtRatio: "UT%",
      fieldTreatment: "處理方式",
      fieldBoltGrade: "等級",
      fieldBoltSize: "尺寸",
      fieldOrigin: "起點",
      fieldDestination: "迄點",
      fieldTruckType: "車型",
    },
    importModal: {
      loading: "載入中…",
      noOrder: "查無採購單。",
      noLine: "此採購單沒有商品明細。",
      title: "從採購單帶入明細",
      description: "可跨多張採購單挑選項目，帶入後規格唯讀、數量可調整。",
      search: "搜尋單號 / 專案",
      lineCount: "{{n}} 筆明細",
      linesOf: "{{po}} 明細",
      selectAll: "全選",
      deselectAll: "反選",
      colSeq: "項次",
      colNameSpec: "品名 / 規格",
      colMaterial: "材質",
      colPoQty: "採購量",
      colRfqQty: "詢價量",
      basket: "已選籃",
      basketCount: "{{orders}} 張單 ・ {{lines}} 筆",
      basketEmpty: "勾選中間欄的項目後，會累計顯示在這裡。",
      removePick: "移除",
      cancel: "取消",
      importCount: "帶入 {{n}} 筆",
    },
    vendor: {
      search: "搜尋廠商名稱 / 統編",
      noPartner: "查無合作方。",
      alreadyInvited: "已加入",
      cancel: "取消",
      addConfirm: "加入 {{n}} 家",
      markDeclined: "標記婉拒",
      remove: "移除",
      empty: "尚無受詢廠商，點「加入廠商」從合作方選取。",
      sectionTitle: "受詢廠商",
      addVendor: "加入廠商",
      sent: "已發出",
      received: "已收到",
      declined: "婉拒",
      pending: "未回",
      colName: "廠商名稱",
      colTaxId: "統編",
      colContact: "聯絡人",
      colPhone: "電話",
      colReply: "回覆狀態",
      colAction: "操作",
      recordQuote: "代錄報價",
      recordNegotiation: "代錄議價",
      fallbackName: "廠商",
    },
    record: {
      deliveryDate: "承諾交期",
      taxIncluded: "報價含稅",
      remark: "備註",
      quoteUnitLocked: "後端以詢價單位計價，報價單位固定同詢價明細",
      title: "代錄報價 — {{vendor}}",
      descriptionNew: "以電話 / Email / 傳真回覆的報價，由承辦代為登錄。",
      descriptionReQuote: "廠商回覆議價，填入本次報價；系統會保留前次報價並計算降幅。",
      supplied: "可供應",
      unitPrice: "報價單價",
      quoteUnit: "報價單位",
      freightIncluded: "含運至工地",
      requirement: "需求",
      cancel: "取消",
      save: "儲存報價",
    },
    pricing: {
      freightDapDisabled: "後端未提供廠商運費總額，暫不支援運費分攤",
      taxBasis: "稅別基準",
      taxExcl: "未稅",
      taxIncl: "含稅",
      freightBasis: "運費基準",
      freightExw: "出廠",
      freightDap: "含運至工地",
      autoAward: "一鍵帶入最低價",
      legendBest: "最低價",
      legendClose: "≤3% 接近",
      legendOver: "超過目標價",
      legendNegotiated: "已議價降幅",
      legendMissing: "缺項/未報",
      legendFormula: "指向單價看換算公式",
      legendExpand: "點項次展開報價明細與議價歷程",
      negotiatedTag: "議價",
      tableTitle: "比價表",
      colLine: "項次 / 品名規格",
      colBase: "基準",
      colTarget: "目標單價",
      missing: "缺項",
      cannotCompare: "無法比價",
      vsBest: "+{{pct}}% vs 最低",
      vsTarget: "{{pct}}% vs 目標",
      negotiatedFrom: "議價前 {{from}} 元/{{fromUnit}} → 現 {{to}} 元/{{toUnit}}",
      vendorTotal: "廠商調整後總額（{{tax}}・{{freight}}）",
      detailTitle: "報價明細與議價歷程",
      noQuote: "本項尚無廠商報價。",
      best: "最低",
      quote: "報價",
      converted: "換算基準",
      subtotal: "小計",
      freight: "運費",
      freightIncluded: "含運至工地",
      freightExcluded: "出廠價（另計運費）",
      alternative: "替代料",
      altApproved: "已核准",
      altPending: "待核准",
      negotiation: "議價",
      firstQuote: "初次報價，未議價",
    },
    award: {
      skipReasonDisabled: "後端未提供不採購原因欄位，暫時無法儲存",
      reviewNotice: "此詢價單審核中，可核准或駁回。",
      rejectReason: "駁回原因",
      reject: "駁回",
      approve: "核准",
      sectionTitle: "決標區",
      decided: "已決定 {{decided}}/{{total}} 項",
      buyerNotice: "決標由採購主管執行，承辦僅可檢視比價結果。",
      selectVendor: "選擇得標廠商",
      skipReason: "不採購原因",
      skip: "本次不採購",
      resume: "恢復採購",
      total: "決標總額（未稅）",
      targetTotal: "目標金額",
      diff: "與目標差異",
      save: "儲存決標",
      submit: "送出審核",
    },
    history: {
      action: {
        created: "建立詢價單",
        proxyQuoteRecorded: "代錄報價",
        vendorDeclined: "廠商婉拒",
        proxyNegotiationRecorded: "代錄議價",
        submittedForReview: "送出審核",
        approved: "審核通過",
        rejected: "審核駁回",
      },
      empty: "尚無歷程紀錄。",
      system: "系統",
      detailRejected: "駁回原因：{{reason}}",
      detailNegotiation: "{{item}} 單價 {{from}} → {{to}}",
      detailQuote: "{{item}} 單價 {{price}}",
      sectionTitle: "歷程",
      actor: "操作人",
      recordedDetail: "代錄 {{n}} 項報價",
    },
    calc: {
      manualInput: "人工輸入",
      manualOverride: "人工覆寫",
      quote: "報價",
      lineWeight: "本項總重",
      freightShare: "運費分攤",
      compareBase: "比價基準",
      noWeight: "無總重，無法換算",
      perUnit: "元/{{unit}}",
      pieces: "支",
      unitMismatch: "報價單位 {{quoteUnit}} 與詢價單位 {{lineUnit}} 不同，無法自動換算",
      taxUplift: "含稅 ×1.05",
      freightIncluded: "含運",
      freightApportioned: "加運費分攤",
    },
    export: {
      print: "列印",
      title: "詢價單",
      projectAddress: "工程地址",
      projectName: "工程案名",
      code: "詢價單號",
      printedAt: "製表日期",
      item: "項目",
      vendor: "廠商",
      spec: "規格",
      quotePrice: "詢價單價",
      quoteDate: "詢價日期",
      negotiatedPrice: "議價單價",
      negotiatedDate: "議價日期",
      purchasePrice: "採購單價",
      purchaseDate: "採購日期",
      remark: "備註",
      declined: "婉拒報價",
      notPurchased: "不採購",
      purchaseTitle: "採購單",
      contractQty: "合約數量",
      costPrice: "成本單價",
      customerPrice: "客戶單價",
      handler: "經辦",
      manager: "經理",
      vicePresident: "副總",
    },
  },
  warehouseMap: {
    zoneLabel: "{{name}} 區",
    newSlot: "新儲位",
    itemCount_one: "{{count}} 品項",
    itemCount_other: "{{count}} 品項",
    slotCount_one: "{{count}} 儲位",
    slotCount_other: "{{count}} 儲位",
    cancel: "取消",
    confirm: "確認",
    instructions: "操作說明",
    page: {
      title: "倉儲管理系統",
      selected: "已選取:",
      pressDeleteHint: "(按 Delete 刪除)",
    },
    floorPlanUpload: {
      title: "上傳倉庫平面圖",
      hint: "點擊上傳圖片，或直接拖曳繪製區域",
    },
    rename: {
      nameRequired: "請輸入名稱",
      chooseIcon: "選擇 icon（選填）",
      searchIcon: "搜尋 icon（中文）",
      noIcon: "無 icon",
      noIconFound: "找不到符合的 icon",
      iconHint: "可在名稱開頭加上一個 icon（選填），顯示結果如：",
    },
    slotTemplate: {
      clickToRenameZone: "點擊編輯區域名稱",
      subtitle: "拖曳儲位到區域內建立新儲位",
      templates: "儲位範本",
      dragIntoZone: "拖曳至區域內",
      slotsInZone: "旗下儲位 ({{count}})",
      noSlots: "尚無儲位，拖曳上方範本至區域內建立",
      instrDragTemplate: "拖曳上方儲位範本到畫布區域內",
      instrClickSlot: "點擊儲位可選取並查看內容",
      instrResize: "選取後可拖曳控制點調整大小",
      instrDelete: "按 Delete 鍵刪除選取的儲位",
      homeTip: "提示：點擊左上角 Home 按鈕可返回倉庫總覽",
      renameZoneTitle: "編輯區域名稱",
      zoneNameLabel: "區域名稱",
    },
    slotDetail: {
      selectProductRequired: "請選擇商品",
      duplicateProduct: "此儲位已有相同商品",
      invalidQuantity: "請輸入有效的數量",
      invalidLimit: "請輸入有效的上限",
      addItem: "新增商品",
      editItem: "編輯商品",
      product: "商品",
      selectProduct: "選擇商品",
      productNotFound: "找不到商品",
      quantity: "數量",
      limit: "上限",
      confirmAdd: "確認新增",
      saveChanges: "儲存變更",
      deleteItem: "刪除商品",
      confirmDeleteItem: "確認要刪除商品「<b>{{name}}</b>」嗎？此動作無法復原。",
      confirmDelete: "確認刪除",
      emptyState: "選擇一個儲位來查看內容",
      clickToRenameSlot: "點擊編輯儲位名稱",
      slotTitle: "儲位 {{name}}",
      productCount_one: "{{count}} 項商品",
      productCount_other: "{{count}} 項商品",
      saveLayoutFirst: "請先儲存配置後再管理此儲位的商品",
      productName: "商品名稱",
      renameSlotTitle: "編輯儲位名稱",
      slotNameLabel: "儲位名稱",
    },
    toolbar: {
      removeFloorPlan: "移除平面圖",
      removeFloorPlanConfirm: "確定要移除目前的平面圖底圖嗎？此操作無法復原。",
      remove: "移除",
      replaceFloorPlan: "更換平面圖",
      uploadFloorPlan: "上傳平面圖",
      floorPlanOverviewOnly: "平面圖（僅倉庫總覽可用）",
      editFloorPlan: "編輯平面圖（拖曳移動 / 邊角縮放）",
      editFloorPlanOverviewOnly: "編輯平面圖工具（僅倉庫總覽可用）",
      removeFloorPlanOverviewOnly: "移除平面圖（僅倉庫總覽可用）",
      selectTool: "選取 / 移動（拖曳平移）",
      selectToolOverviewOnly: "選取工具（僅倉庫總覽可用）",
      drawZone: "繪製區域（拖曳建立）",
      drawZoneOverviewOnly: "繪製區域工具（僅倉庫總覽可用）",
      zoomIn: "放大",
      zoomOut: "縮小",
      backToOverview: "回到倉庫總覽",
      collapseInstructions: "收合操作說明",
      expandInstructions: "展開操作說明",
      instrSelectTool: "選取工具：拖曳平移、單擊選取、雙擊進入",
      instrDrawTool: "繪製工具：拖曳建立區域",
      instrFloorPlanTool: "平面圖工具：拖曳移動、邊角縮放",
      instrDragSlot: "從右側拖曳建立儲位",
      instrClickSlot: "點擊儲位查看內容",
      instrClickZone: "點擊區域空白處選取區域",
      instrMoveResize: "選取後拖曳移動或縮放",
      instrZoom: "滾輪 / 雙指縮放，或 + − 鍵",
      instrPan: "兩指滑動 / Alt+拖曳 平移",
    },
  },
  itemEditor: {
    notify: {
      loadFailed: "載入品項失敗",
      created: "品項已建立",
      createFailed: "建立品項失敗",
      saved: "品項已儲存",
      saveFailed: "儲存品項失敗",
      copied: "已複製為新品項",
      copyFailed: "複製品項失敗",
    },
    panel: {
      title: "編輯品項",
      presetData: "預設資料",
      emptyTitle: "請選擇品項",
      emptyHint: "從左側列表選擇品項進行編輯，或點擊「新增品項」建立新品項",
    },
    field: {
      category: "品項分類",
      steelType: "型鋼類型",
      screwType: "螺絲類型",
      sectionSpec: "斷面規格",
      name: "品項名稱",
      namePlaceholder: "輸入品項名稱",
      description: "描述",
      descriptionPlaceholder: "輸入品項描述...",
    },
    weight: {
      title: "單位面積重",
      area: "斷面積：",
      unitWeight: "單位重：",
    },
    action: {
      cancel: "取消",
      close: "關閉",
      copyAndEdit: "複製並編輯",
      save: "儲存品項",
    },
    addDialog: {
      title: "新增品項",
      submit: "建立品項",
      selectCategory: "選擇分類",
      selectSteelType: "選擇型鋼類型",
      selectScrewType: "選擇螺絲類型",
      specPreview: "規格：{{spec}}",
    },
    grid: {
      searchPlaceholder: "搜尋品項名稱 / 規格",
      filter: "篩選",
      addItem: "新增品項",
      preset: "預設",
      total: "共 {{total}} 筆",
      perPage: "{{size}} / 頁",
    },
    sidebar: {
      noData: "尚無資料",
    },
    category: {
      all: "全部品項",
      steel: "型鋼",
      screw: "螺絲",
      parts: "鋼構配件",
      consumables: "鋼構耗材",
      hardware: "五金配件",
      uncategorized: "未分類",
    },
    steelType: {
      TUBE: "方管",
      BOX: "箱型鋼",
      H: "H型鋼",
      RH: "熱軋H型鋼",
      BH: "焊接H型鋼",
      I: "I型鋼",
      L: "角鋼",
      U: "槽鋼",
      BT: "BT型鋼",
      CT: "CT型鋼",
      T: "T型鋼",
      C: "C型鋼",
      PIPE: "圓管",
      FB: "扁鋼",
      RB: "圓棒",
    },
    screwType: {
      hexBolt: "六角螺栓",
      hexNut: "六角螺帽",
      washer: "墊圈",
      highStrengthBoltSet: "高張力螺絲組",
      anchorBolt: "錨栓",
      shearStud: "剪力釘",
    },
    specField: {
      width: "寬",
      height: "高",
      thickness: "厚",
      flangeThickness: "翼板厚",
      webThickness: "腹板厚",
      legA: "邊長A",
      legB: "邊長B",
      lip: "唇邊",
      outerDiameter: "外徑",
      diameter: "直徑",
    },
  },
  companyCalendar: {
    title: "行事曆",
    description: "公司共用行事曆，可依員工標籤分類與篩選事件",
    monthView: "月曆",
    filterPlaceholder: "依員工標籤過濾（未選擇顯示全部）",
    clickHint: "點擊日期新增事件，點擊事件可編輯或刪除",
    subscribe: "訂閱行事曆",
    subscribeTitle: "訂閱行事曆",
    subscribeHint: "使用手機相機或行事曆 App 掃描 QR code 即可訂閱",
    subscribeUnavailable: "無法取得訂閱網址，請稍後再試",
    subscribeScope: "訂閱範圍：",
    copyLink: "複製連結",
    copied: "已複製連結",
    copyFailed: "複製失敗",
    close: "關閉",
    loading: "載入中…",
    addEvent: "新增事件",
    editEvent: "編輯事件",
    eventTitle: "標題",
    eventTitlePlaceholder: "例如：月會、廠區消防演練",
    titleRequired: "請輸入標題",
    dateRequired: "請選擇日期",
    allDay: "全天",
    visibleTags: "員工標籤",
    visibleTagsHint: "標籤用於分類與篩選事件；未選擇則視為全體員工的事件",
    allEmployees: "全體員工",
    unknownTag: "（已刪除標籤）",
    currentlyVisibleTo: "目前標籤：",
    location: "地點",
    eventDescription: "說明",
    save: "儲存",
    cancel: "取消",
    delete: "刪除",
    deleteConfirm: "確定要刪除此事件？",
    createSuccess: "已新增事件",
    updateSuccess: "已更新事件",
    saveFailed: "儲存失敗",
    deleteSuccess: "已刪除事件",
    deleteFailed: "刪除失敗",
    moreEvents: "還有 {{count}} 個",
    dateRange: "日期（可跨多天）",
    dateTimeRange: "開始 ～ 結束時間",
    dateRangeHint: "選擇開始與結束日期，跨多天的事件會顯示在每一天",
    loadFailed: "載入行事曆失敗",
    isCompleted: "已完成",
    createdBy: "建立者：",
    updatedBy: "最後修改：",
    auditInfo: "建立與修改紀錄",
    subscribeGoogle: "加入 Google 日曆",
    subscribeApple: "加入 Apple 行事曆",
    color: "顏色",
    colorHint: "未指定時依第一個員工標籤自動配色",
    colorAuto: "自動（依標籤）",
    colorCustom: "自訂",
    endBeforeStart: "結束時間必須晚於開始時間",
    prevMonth: "上個月",
    nextMonth: "下個月",
    today: "今天",
  },
  warRoom: {
    common: {
      none: "（無）",
      notFilled: "（未填）",
      unnamed: "（未命名）",
      uncategorized: "（未分類）",
      noData: "（無資料）",
      other: "其他",
      count: "筆數",
    },
    groups: {
      basic: "基本資訊",
      partner: "合作方",
      project: "專案管理",
      purchase: "採購",
      product: "商品",
      warehouse: "倉儲",
      finance: "財務",
    },
    datasets: {
      employee: {
        label: "員工",
        description: "公司底下所有員工，可看人數分佈、駕照持有率。",
        fields: {
          name: "姓名",
          status: "狀態",
          gender: "性別",
          bloodType: "血型",
          birthday: "生日",
          motorbikeLicense: "機車駕照",
          carLicense: "汽車駕照",
          isProjectReport: "專案回報者",
        },
      },
      partner: {
        label: "合作方",
        description: "所有合作方（客戶／供應商），可看狀態與發票種類分佈。",
        fields: {
          name: "名稱",
          status: "停用狀態",
          invoiceType: "發票種類",
          business: "營業項目",
          applicationDate: "申請日期",
        },
      },
      project: {
        label: "專案",
        description: "專案列表，含合作方與節點數。可看每月開案數、結案比例。",
        fields: {
          name: "專案名稱",
          status: "專案狀態",
          partnerName: "合作方",
          date: "開案日期",
          nodeCount: "節點數",
        },
      },
      projectNode: {
        label: "專案節點（構件統計）",
        description: "專案節點與構件加工統計（待加工／進行中／已完成），適合看各專案的加工進度。",
        fields: {
          name: "節點名稱",
          nodeType: "節點型別",
          projectName: "所屬專案",
          pending: "待加工構件",
          inProgress: "進行中構件",
          completed: "已完成構件",
          totalAssemblies: "構件總數",
          completedRatio: "完成率 %",
        },
      },
      workItem: {
        label: "工項（含完成狀態）",
        description: "所有工項與是否完成。workItem 後端沒有帶出關聯，專案名稱是用 projectNodeId 在前端 join projectNode → project。",
        fields: {
          name: "工項名稱",
          projectName: "所屬專案",
          nodeName: "所屬節點",
          isCompleted: "是否完成",
          scanMode: "掃描模式",
          plannedCompletionDate: "預計完成日",
          completedCount: "已完成計數",
        },
      },
      purchaseOrder: {
        label: "採購單",
        description: "採購單含明細金額（由 purchaseOrderProduct 的數量×單價加總）。可看各狀態、各合作方採購金額。",
        fields: {
          name: "採購單名稱",
          status: "訂單狀態",
          partnerName: "合作方",
          purchaseDate: "採購日期",
          deliveryDate: "交貨日期",
          applicationDate: "申請日期",
          deliveryMethod: "交貨方式",
          shippingFeeCalculation: "運費方式",
          orderAmount: "採購金額",
          actualShippingFee: "實際運費",
          lineCount: "明細品項數",
          totalQuantity: "採購總數量",
          requiresInvoice: "是否開發票",
        },
      },
      purchaseOrderProduct: {
        label: "採購單明細",
        description: "逐筆採購明細，可看單一商品的採購量與金額。",
        fields: {
          productName: "商品",
          orderName: "採購單",
          orderStatus: "訂單狀態",
          partnerName: "合作方",
          amount: "數量",
          unitPrice: "單價",
          lineTotal: "小計",
        },
      },
      product: {
        label: "商品",
        description: "商品主檔，可看材質分佈、單位重與長度關係（散佈圖）。",
        fields: {
          name: "商品名稱",
          partnerName: "供應商",
          itemName: "品項",
          mainCategory: "主分類",
          subCategory: "子分類",
          material: "材質",
          unit: "單位",
          length: "長度",
          unitWeight: "單位重",
          inventoryLowerLimit: "庫存下限",
        },
      },
      item: {
        label: "品項",
        description: "品項主檔，可看主分類／子分類的品項數。",
        fields: {
          name: "品項名稱",
          mainCategory: "主分類",
          subCategory: "子分類",
        },
      },
      productInventory: {
        label: "商品庫存",
        description: "各儲位的商品庫存量與上限，可看庫存量前幾名、水位比。",
        fields: {
          productName: "商品",
          storageLocationName: "儲位",
          material: "材質",
          amount: "庫存數量",
          inventoryUpperLimit: "庫存上限",
          utilization: "水位 %",
        },
      },
      warehouse: {
        label: "倉庫",
        description: "倉庫主檔與啟用狀態。",
        fields: {
          name: "倉庫名稱",
          enable: "啟用",
        },
      },
      storageLocation: {
        label: "儲位",
        description: "儲位主檔與啟用狀態。",
        fields: {
          name: "儲位名稱",
          enable: "啟用",
        },
      },
      stockReceipt: {
        label: "入庫單",
        description: "入庫單，含建立時間，可看每月入庫單量。",
        fields: {
          name: "單號名稱",
          status: "狀態",
          deliveryPerson: "送貨人員",
          createdAt: "建立日期",
        },
      },
      stockRequest: {
        label: "領料單",
        description: "領料單，含建立時間，可看每月領料單量。",
        fields: {
          name: "單號名稱",
          status: "狀態",
          deliveryPerson: "送貨人員",
          createdAt: "建立日期",
        },
      },
      financeArAp: {
        label: "應收應付（合併對比）",
        description: "應收與應付合併成一份資料，用「類型」當數列就能直接對比。注意：應付帳款主表沒有日期欄位，日期取自明細最早的發票日期。",
        fields: {
          kind: "類型",
          name: "單據名稱",
          partnerName: "合作方",
          date: "日期（應收＝請款日／應付＝發票日）",
          requestedAmount: "請款金額（未稅）",
          amountWithTax: "請款金額（含稅）",
          taxRate: "稅率 %",
          paidAmount: "已收付金額",
          outstandingAmount: "未收付餘額",
          detailCount: "明細筆數",
          isFullySettled: "是否全數結清",
        },
      },
      accountsReceivable: {
        label: "應收帳款",
        description: "應收帳款主表，含合作方與收款明細加總。日期＝請款日期。",
        fields: {
          name: "單據名稱",
          partnerName: "合作方",
          date: "請款日期",
          requestedAmount: "請款金額（未稅）",
          amountWithTax: "請款金額（含稅）",
          taxRate: "稅率 %",
          paidAmount: "已收付金額",
          outstandingAmount: "未收付餘額",
          detailCount: "明細筆數",
          isFullySettled: "是否全數結清",
        },
      },
      accountsPayable: {
        label: "應付帳款",
        description: "應付帳款主表。後端 schema 沒有日期欄位，日期取自明細最早的發票日期，要精準的時間軸請用「應付帳款明細」。",
        fields: {
          name: "單據名稱",
          partnerName: "合作方",
          date: "日期（取明細最早發票日）",
          requestedAmount: "請款金額（未稅）",
          amountWithTax: "請款金額（含稅）",
          taxRate: "稅率 %",
          paidAmount: "已收付金額",
          outstandingAmount: "未收付餘額",
          detailCount: "明細筆數",
          isFullySettled: "是否全數結清",
        },
      },
      accountsDetail: {
        label: "應收應付明細（含收付日期）",
        description: "逐筆收付明細，兩邊都有 paymentDate／invoiceDate，是財務時間軸最準的資料來源。",
        fields: {
          kind: "類型",
          bankName: "銀行",
          paymentMethod: "付款辦法",
          paymentDate: "收付日期",
          invoiceDate: "發票日期",
          checkClearanceDate: "支票兌現日",
          amount: "收付金額",
          handlingFee: "手續費",
          retentionAmount: "保留款",
          deductionAmount: "扣款金額",
          netAmount: "淨額",
          isSettled: "是否結清",
        },
      },
      bank: {
        label: "銀行帳戶",
        description: "銀行帳戶餘額。",
        fields: {
          name: "銀行名稱",
          balance: "餘額",
        },
      },
    },
    enums: {
      projectStatus: {
        normal: "正常",
        close: "結案",
      },
      purchaseOrderStatus: {
        draft: "草稿",
        underReview: "審核中",
        approved: "已審核",
        rejected: "已拒絕",
        completed: "已完成",
      },
      paymentMethod: {
        check: "支票",
        transfer: "匯款",
        cash: "現金",
        credit: "信用卡",
      },
      deliveryMethod: {
        single: "一次出貨",
        partial: "分批出貨",
      },
      shippingFeeCalculation: {
        freeShipping: "免運",
        shippingFeeRequired: "需運費",
      },
      nodeType: {
        building: "整體建築",
        zone: "分區",
        batch: "分批",
        package: "構件包",
      },
      scanMode: {
        multiple: "複數",
        single: "單支",
        all: "全部",
      },
      employeeStatus: {
        normal: "正常",
        resigned: "離職",
      },
      partnerStatus: {
        normal: "正常",
        underReview: "審核中",
        disabled: "已停用",
      },
      stockDocStatus: {
        normal: "正常",
        done: "結案",
      },
      accountKind: {
        AR: "應收",
        AP: "應付",
      },
      bool: {
        true: "是",
        false: "否",
      },
    },
    chartForms: {
      line: {
        label: "折線圖",
        job: "看時間趨勢",
      },
      area: {
        label: "面積圖",
        job: "看單一數列的時間趨勢",
      },
      column: {
        label: "直條圖",
        job: "比大小（類別不多、名稱短）",
      },
      bar: {
        label: "橫條圖",
        job: "比大小（類別多、名稱長）",
      },
      groupedColumn: {
        label: "分組直條圖",
        job: "同一類別下比較幾個數列",
      },
      stackedColumn: {
        label: "堆疊直條圖",
        job: "看組成（部分對全體）",
      },
      stackedBar: {
        label: "堆疊橫條圖",
        job: "看組成（類別多或名稱長）",
      },
      pie: {
        label: "圓餅圖",
        job: "一眼看比例（分段 ≤ 6 才用）",
      },
      scatter: {
        label: "散佈圖",
        job: "看兩個量值的關係",
      },
      heatmap: {
        label: "熱區圖",
        job: "看兩個維度交叉的量值大小",
      },
    },
    aggregation: {
      count: "筆數",
      sum: "總和",
      avg: "平均",
      min: "最小",
      max: "最大",
      countDistinct: "相異數",
    },
    aggregate: {
      valueLabel: "{{agg}}（{{field}}）",
      warnings: {
        scatterSeriesFolded: "散佈圖任兩個顏色都可能相鄰，安全上限是 {{cap}} 個數列；其餘 {{folded}} 個已折成「{{other}}」（灰色）。要逐一比較請改用分面或分組直條圖。",
        emptyTime: "有 {{count}} 筆的「{{field}}」是空的，無法放上時間軸，已排除。",
        seriesFolded: "數列超過 {{cap}} 個色位上限，其餘 {{folded}} 個已折成「{{other}}」。色盤不會為了多出來的數列生成新顏色 —— 生成色在色盲模式下跟既有顏色分不開。",
        tooManyCategories: "{{chart}}在 {{cap}} 個分段以內才讀得出來，現在有 {{count}} 個。建議調低「只看前 N 名」或改用橫條圖／表格。",
        nonAdditiveFold: "「{{agg}}」不能直接相加，折成「{{other}}」的那一格是各組各自算完再加起來，數字僅供參考。要精確請改用「{{sum}}」或「{{count}}」。",
      },
    },
    table: {
      item: "項目",
      series: "數列",
      category: "類別",
      total: "合計",
    },
    chart: {
      noData: "這個組合沒有資料。換一個 X 軸欄位或放寬日期範圍看看。",
    },
    errors: {
      forbidden: "沒有「{{resource}}」的讀取權限，請確認這個帳號在該公司的角色。（原始訊息：{{message}}）",
      pickDatasetFirst: "先在左邊「① 選資料」挑一份資料，再把圖表拖進畫布。",
      unsupportedChart: "「{{dataset}}」畫不出{{chart}}（欠缺需要的欄位型別）。",
    },
    export: {
      noWidgets: "畫布上沒有圖可以輸出。",
      unsupported: "這個瀏覽器不支援輸出圖片。",
      failed: "輸出圖片失敗。",
    },
    toolbox: {
      title: "工具箱",
      collapse: "收起工具箱",
      exportTooltip: "輸出畫布（PNG）",
      export: "輸出畫布",
      clearCanvas: "清空畫布",
      clearConfirm: "畫布上的 {{count}} 張圖都會移除，這台瀏覽器的存檔也一起清掉。",
      clearOk: "清空",
      clearCancel: "不要",
      reload: "重新抓資料（清掉快取，畫布上每份資料都重抓）",
      reset: "全部重來（清空畫布）",
      steps: {
        data: "選資料",
        dataValue: "新圖：{{name}}",
        chart: "圖表",
        chartValue: "畫布上 {{count}} 張",
        axis: "調這張圖的 X / Y 軸",
      },
    },
    dataPanel: {
      hintBefore: "接下來拖進畫布的",
      hintStrong: "新圖",
      hintAfter: "用這份資料。 畫布上已經有的圖不會被換掉 —— 同一塊畫布可以放不同資料的圖（例如專案一張、應收一張）。",
      search: "搜尋資料或欄位",
      noAccess: "這個帳號在目前公司沒有可以讀的資料，請確認角色權限。",
      noMatch: "沒有符合的資料",
    },
    chartPanel: {
      pickDatasetFirst: "先在上一步選一份資料。",
      hint: "「{{dataset}}」畫得出來的 {{count}} 種 —— 拖到右邊畫布，或點一下直接放進去：",
      dragTitle: "拖到畫布，或點一下加到畫布：{{chart}}",
      noDualAxis: "沒有雙軸圖：兩條軸的對齊方式是任意的，會造出資料裡沒有的相關性。要比兩個量值請用散佈圖。",
    },
    inspector: {
      empty: "點畫布上的一張圖，這裡就會變成那張圖的 X / Y 軸設定。",
      dataset: "這張圖的資料",
      chartType: "圖型",
      filter: "篩選（期間、維度）",
    },
    axis: {
      empty: "點畫布上的一張圖，這裡可以指定它的 X / Y 軸。",
      highCardinality: "{{field}}（值很多）",
      suggested: "適合這種圖",
      otherFields: "其他欄位",
      noMeasure: "不用量值",
      countOption: "筆數（每段有幾筆）",
      measures: "量值（可加總、平均）",
      othersDistinct: "其他欄位（算相異數）",
      x: "X 軸",
      xMeasure: "X 軸（量值）",
      xPlaceholder: "選 X 軸欄位",
      y: "Y 軸",
      yMeasure: "Y 軸（量值）",
      yPlaceholder: "選 Y 軸欄位",
      grain: {
        day: "日",
        week: "週",
        month: "月",
        quarter: "季",
        year: "年",
      },
      notSuggestedTime: "「{{field}}」不是{{chart}}的建議 X 軸，分段會依上面的時間單位切。",
      notSuggestedDim: "「{{field}}」不是{{chart}}的建議 X 軸，分段可能很多；用下面的「只看前 N 名」收斂。",
      aggregation: "聚合方式",
      distinctOnly: "「{{field}}」不是量值，加總或平均沒有意義， 只能算{{agg}}（每段有幾個不同的值）。",
      seriesRequired: "分組（必填）",
      seriesOptional: "分組（可不選）",
      noSeries: "不分組",
      seriesPlaceholder: "選分組欄位",
      seriesHint: "分組只能用維度欄位，不能是第二個量值。",
      scatterHint: "散佈圖的數列上限是 3：任兩個顏色都可能相鄰，超過的會折成灰色的「其他」。",
      more: "更多設定（排序、只看前 N 名）",
      sort: "排序",
      sortBy: {
        valueDesc: "值：大 → 小",
        valueAsc: "值：小 → 大",
        x: "依 X 軸名稱",
      },
      topNAll: "只看前 N 名（全部）",
      topN: "只看前 N 名（{{n}}）",
      topNHint: "其餘折成「其他」，不會憑空生成新顏色。",
    },
    filter: {
      period: "期間",
      quick: {
        all: "全部期間",
        m1: "本月",
        m3: "近 3 個月",
        m12: "近 12 個月",
        y: "今年",
        custom: "自訂…",
      },
      byField: "依 {{field}}",
      noDateField: "這份資料沒有日期欄位，無法做時間篩選。",
      onlyValues: "只看這些值",
      clear: "清除",
    },
    widget: {
      noDataset: "這張圖還沒有資料集",
      fetchFailed: "抓資料失敗",
      rows: "{{n}} 筆",
      noDatasetPicked: "未選資料",
      viewTable: "看表格",
      viewChart: "看圖表",
      duplicate: "複製這張圖",
      remove: "從畫布移除",
      resize: "調整大小",
    },
    canvas: {
      emptyTitle: "畫布是空的",
      emptyHint: "先在左邊「① 選資料」挑一份資料，再把「② 圖表」裡的圖型<strong>拖到這裡</strong>（或點一下）。",
      emptyMulti: "一塊畫布可以放多張圖：拖標題列移動、拉右下角改大小、點一張圖就能在左邊調它的 X / Y 軸。",
      emptyMixed: "不同資料的圖可以放在同一塊畫布上 —— 回第 ① 步換一份資料，再拖一張進來就好。",
    },
    page: {
      restored: "已還原上次的畫布（{{count}} 張圖）",
      synced: "已同步雲端的畫布（{{count}} 張圖）",
      exportFileName: "畫布-{{date}}.png",
      exported: "已輸出畫布 PNG",
      exportFailed: "輸出失敗",
      expandToolbox: "展開工具箱",
    },
  },
};
